// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-21T20:23:07.806Z
// Property: Corn Dog Manufacturer (ID: 6767906449167478)
// Collections: 2 amenities, 8 floorplans (live), 48 photos, 73 POIs, 3 reviews, 5 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162273",
  "multihub_property_id": "6767906449167478",
  "property_external_id": null,
  "property_zillow_url": null,
  "property_apartments_url": null,
  "property_google_business_url": null,
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": null,
  "property_pm_software": null,
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "corn-dog-manufacturer",
  "property_name": "Corn Dog Manufacturer",
  "property_website_url": "https://www.corndog2.me",
  "property_domain": "https://corndog2.me",
  "property_address": "1000 Davis St",
  "property_full_address": "1000 Davis St, Livingston, CA 95334",
  "property_address_1": "1000 Davis St",
  "property_address_2": null,
  "property_address_city": "Livingston",
  "property_address_state": "CA",
  "property_address_zip_full": null,
  "property_address_zip": "95334",
  "property_address_country": "US",
  "property_address_county": "Merced County",
  "property_neighborhood_address": null,
  "property_address_latitude": "37.3904144",
  "property_address_longitude": "-120.7249839",
  "property_email": null,
  "property_phone": "(209) 394-7901",
  "property_call_tracking_phone": null,
  "property_company_name": "Repli Sandbox",
  "property_company_url": "testurl.com",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>A Central Valley original with everyday convenience.</strong> Explore streamlined studio-style options in Livingston, with free lot parking, accessible building features, and quick Highway 99 connections—then view available floor plans to find your fit.</p>",
  "property_long_description": "<p><strong>A Central Valley original with everyday convenience.</strong> Corn Dog Manufacturer puts you in Livingston, where Foster Farms’ long-running food-production presence and the city’s Highway 99 location anchor a practical, easy-to-navigate address. Here, you can choose streamlined studio-style options inspired by classic chicken and turkey corn dog favorites, including lower-fat, whole-grain, stickless, bagged, and individually wrapped selections.</p><p>The setting keeps daily logistics simple, with <a href=\"/amenities\">free lot parking</a>, accessible building features, and quick connections to Main Street, C Street services, and nearby Highway 99. When you want a change of pace, Max Foster Sports Complex brings 25 acres of fields, courts, and picnic space, Memorial Park adds shade and community green space, and McConnell State Recreation Area places the Merced River within easy reach. Explore the full lineup of <a href=\"/floor-plans\">studio floor plans</a>, then see more local highlights on the <a href=\"/neighborhood\">neighborhood</a> page.</p>",
  "property_featured_image": null,
  "property_featured_image_media": null,
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": null,
  "property_year_built": null,
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": null,
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": null,
  "property_allows_cats": null,
  "property_allows_dogs": null,
  "property_upfront_pet_fee": null,
  "property_pet_deposit": null,
  "property_monthly_pet_rent": null,
  "property_max_pets": null,
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": null,
  "property_pet_policy_description": null,
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": null,
  "property_apply_now_url": null,
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-e6fa-7404-adf1-9d01f32a6f36.webp",
  "property_primary_logo_media": {
    "alt_text": "Foster Farms logo with a rooster and yellow background",
    "public_id": "019f630a-e6fa-7404-adf1-9d01f32a6f36",
    "storage_key": "property/6767906449167478/019f630a-e6fa-7404-adf1-9d01f32a6f36.webp",
    "width": 346,
    "height": 321
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630b-811e-71ec-ba2a-99bb5a61f356.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019f630b-811e-71ec-ba2a-99bb5a61f356",
    "storage_key": "property/6767906449167478/019f630b-811e-71ec-ba2a-99bb5a61f356.webp",
    "width": 346,
    "height": 321
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630b-7364-75ec-81e8-e0231d13f041.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019f630b-7364-75ec-81e8-e0231d13f041",
    "storage_key": "property/6767906449167478/019f630b-7364-75ec-81e8-e0231d13f041.webp",
    "width": 346,
    "height": 321
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162273/019cfdd9-c8a4-71d3-8bff-111ee22aee5d.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162273/019d2713-d4f5-701a-91f4-9c4e82dc6c6b.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162273/019d2705-ea93-721c-8d4f-e2d2a439a839.webp",
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": null,
  "property_secondary_color": null,
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": null,
  "property_bedrooms_min": null,
  "property_bedrooms_max": null,
  "property_bathrooms_range": null,
  "property_bathrooms_min": null,
  "property_bathrooms_max": null,
  "property_sqft_range": null,
  "property_sqft_min": null,
  "property_sqft_max": null,
  "property_price_range": null,
  "property_price_min": null,
  "property_price_max": null,
  "property_available_units": null,
  "property_facebook_url": null,
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJh4ZB73cNkYARwraR-iVrRB4",
  "property_youtube_url": null,
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Corn Dog Manufacturer",
  "property_home_romance_title": "Embrace a Beautiful Life in Your New Apartment Home",
  "property_home_amenities_blurb": "<p><strong>Everyday ease, built right in.</strong> Corn Dog Manufacturer keeps convenience simple with free on-site parking, accessible design details, and a streamlined setting that makes each visit smoother from the moment you arrive. Explore practical amenities that support easy access and let the studio-style lineup stay front and center.</p>",
  "property_home_floorplans_blurb": "<p><strong>Studio options, simplified.</strong> Corn Dog Manufacturer keeps floor plan browsing clear with a focused lineup of classic chicken and turkey concepts, chili-forward selections, whole-grain lower-fat options, stickless designs, bagged formats, and individually wrapped layouts. Compare the featured cards for pricing, availability, and packaging-style details, then click through to explore every studio option in Livingston.</p>",
  "property_home_gallery_blurb": "<p><strong>See Corn Dog Manufacturer at a glance.</strong> Preview simple studio-style layouts, clean arrival areas, on-site parking, and the straightforward details that define this Livingston address.</p><p>From building approach to visual concepts like chicken, turkey, whole-grain, stickless, bagged, and individually wrapped options, the gallery offers a focused first look before you explore in person.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Map out Livingston, then make it your route.</strong> At Corn Dog Manufacturer, 1000 Davis St puts Main Street stops, local favorites like La Morenita and Mayrita’s, and the area’s Foster Farms-rooted working-food heritage close at hand. Highway 99 keeps Merced, Turlock, and Central Valley errands easy to reach, while Max Foster Sports Complex, sweet potato community events, and the Livingston Commuter route add everyday connection. Explore the map, then <a href=\"/schedule-a-tour\">schedule a tour</a>.</p>",
  "property_home_reviews_blurb": "<p><strong>Quick stops, clear details, smooth flow.</strong> Reviews for Corn Dog Manufacturer highlight efficient pickup and delivery experiences, including one 5-star note: “Picking up checkin 7:30am check out 8:30 am.” Browse more feedback for firsthand tips on arrival timing, security gate check-in, shipping and receiving, and what to expect for a fast in-and-out visit.</p>",
  "property_neighborhood_blurb": "<p><strong>See Livingston from the map, then make it your route.</strong> Corn Dog Manufacturer places you close to the Central Valley’s working-food heritage, with Foster Farms’ long-established hometown presence shaping the area’s practical, down-to-earth character. From here, Main Street brings quick local stops like La Morenita and Mayrita’s, while nearby Highway 99 keeps Merced, Turlock, and broader valley errands within a straightforward drive.</p><p>Zoom out and you’ll find more than convenience: community events tied to Livingston’s sweet potato roots, neighborhood recreation at Max Foster Sports Complex, and Merced County Transit’s Livingston Commuter route for regional connections. Use the interactive map to explore what is closest, then <a href=\"/schedule-a-tour\">schedule a tour</a> when you’re ready to see the setting in person.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Everyday ease, built right in.</strong> At Corn Dog Manufacturer, the amenity experience keeps things straightforward: arrive with less hassle, park in the free on-site lot, and move through the property with accessible design details that support a smoother visit from the start.</p><p>Inside the gallery and amenity categories below, you can get a clearer feel for the practical features that matter most day to day—simple access, convenient parking, and a streamlined setting that lets the studio-style lineup take the spotlight. Browse the <a href=\"/gallery\">photo gallery</a> for a closer look, then compare available options on the <a href=\"/floor-plans\">floor plans</a> page when you’re ready to choose your next step.</p>",
  "property_applynow_blurb": "<p><strong>Ready to make it yours?</strong><br>Corn Dog Manufacturer brings streamlined studio-style options to a practical Livingston address with everyday convenience, free lot parking, and accessible building features. Start your online application today and take the next step toward calling 1000 Davis St home.</p>",
  "property_contactus_blurb": "<p><strong>Have questions or need directions?</strong><br>Connect with the Corn Dog Manufacturer leasing team for help finding our easy-to-navigate Livingston address, learning more about streamlined studio-style options, or planning your next step.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Corn Dog Manufacturer?</strong> Start here for quick answers on the community, leasing, studio-style options, and everyday living in Livingston. If you need anything beyond the FAQs, the leasing team is happy to help you find the details you need.</p>",
  "property_floorplans_blurb": "<p><strong>Find the studio setup that fits your day-to-day rhythm.</strong> At Corn Dog Manufacturer, the floor plan collection keeps the choice simple while giving you meaningful variety: classic chicken and turkey corn dog concepts, chili-forward options, whole-grain lower-fat selections, stickless designs, bagged formats, and individually wrapped layouts.</p><p>Use the cards below to compare pricing, availability, and layout details side by side, then narrow in on the studio option with the packaging style and flavor profile that feels right. In Livingston, this streamlined lineup is designed for easy browsing—clear categories, quick comparisons, and no guesswork. Have questions about a specific option? <a href=\"/contact-us\">Contact the leasing team</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to take the next step.</p>",
  "property_gallery_blurb": "<p><strong>Start with the view.</strong> Browse the photo gallery to get a clearer sense of Corn Dog Manufacturer before you visit—simple studio-style layouts, clean arrival areas, and the practical details that shape the experience from the first look.</p><p>As you move through the images, notice the easy flow from the on-site parking area to the building, the straightforward spaces designed for quick comparison, and the visual variety behind the chicken, turkey, whole-grain, stickless, bagged, and individually wrapped studio concepts. It’s a focused snapshot of a Livingston address that keeps convenience front and center without overcomplicating the choice.</p><p>Want to see more than still photos? Explore the <a href=\"/virtual-tours\">virtual tours</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> for a closer look.</p>",
  "property_interactivemap_blurb": "<p><strong>Map out everyday convenience.</strong> Explore available <a href=\"/floor-plans\">studio floor plans</a> and see how Corn Dog Manufacturer connects to Livingston essentials, Main Street, C Street services, Highway 99, and nearby green space—all from the interactive map.</p>",
  "property_pets_blurb": null,
  "property_referafriend_blurb": "<p><strong>Share everyday convenience.</strong><br>Love the practical Livingston location, easy Highway 99 connections, and streamlined studio-style options at Corn Dog Manufacturer? Refer a friend and invite them to discover the same Central Valley original you call home.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access made simple.</strong><br>From rent payments to maintenance requests and account updates, manage everyday details for Corn Dog Manufacturer in one convenient place—supporting the practical, easy-to-navigate Livingston living experience that keeps daily logistics straightforward.</p>",
  "property_reviews_blurb": "<p><strong>Fast, practical, and easy to review at a glance.</strong> Feedback for Corn Dog Manufacturer points to efficient appointment flow, with reviewers noting quick delivery and pickup experiences. One 5-star review sums it up simply: “Picking up checkin 7:30am check out 8:30 am.”</p><p>You’ll also find helpful firsthand notes about arrival timing, security gate check-in, and where to go for shipping and receiving. As you browse the full list of reviews, look for the details that matter most to your visit: timing, check-in steps, and smooth in-and-out experiences.</p>",
  "property_created_at": "1784073038158",
  "property_scheduletour_blurb": "<p><strong>See the Central Valley original in person.</strong> Tour Corn Dog Manufacturer and get a closer look at its streamlined studio-style options, practical Livingston setting, and everyday convenience near Highway 99. Schedule your visit today and explore the details that make this address easy to navigate.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you — we’ve received your inquiry.</strong><br>The leasing team will follow up soon with next steps. Corn Dog Manufacturer brings a Central Valley address with everyday convenience, streamlined studio-style options, free lot parking, and easy connections around Livingston.</p>",
  "property_virtualtours_blurb": null,
  "property_copyright": "2026 All Rights Reserved. Corn Dog Manufacturer",
  "property_seo_title_home": "Corn Dog Manufacturer |  Apartments in Livingston, CA",
  "property_seo_description_home": "Unwind at Corn Dog Manufacturer in Livingston, CA! Enjoy studio living, free parking, and wheelchair-accessible amenities. Your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Livingston, CA Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal living space at Corn Dog Manufacturer in Livingston, CA. Choose from cozy studios and more—browse our unique floor plans today!",
  "property_seo_title_amenities": "Amenities | Livingston, CA Apartments for Rent",
  "property_seo_description_amenities": "Experience comfort at Corn Dog Manufacturer in Livingston, CA. Enjoy accessible living with free parking and stylish studio layouts. Your ideal home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Livingston, CA",
  "property_seo_description_gallery": "Picture yourself at Corn Dog Manufacturer in Livingston, CA! Discover stunning studios, wheelchair access, and free parking. Your next home awaits!",
  "property_seo_title_virtualtours": "Virtual Tours | Corn Dog Manufacturer Apartments",
  "property_seo_description_virtualtours": "Experience vibrant living at Corn Dog Manufacturer in Livingston, CA. Take a virtual tour of our stylish studios and find your perfect home today!",
  "property_seo_title_interactivemap": "Interactive Map | Corn Dog Manufacturer Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Corn Dog Manufacturer in Livingston, CA! Use our interactive community map to explore accessible studios & pricing today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Livingston, CA",
  "property_seo_description_neighborhood": "Uncover the charm of Livingston, CA at Corn Dog Manufacturer! Delight in local favorites and must-see spots just steps from our inviting studio apartments.",
  "property_seo_title_contact": "Contact Us | Corn Dog Manufacturer",
  "property_seo_description_contact": "Transform your living experience at Corn Dog Manufacturer in Livingston, CA! Explore studio floor plans tailored for you. Got questions? Reach out today!",
  "property_seo_title_faqs": "FAQs | Apartments in Livingston, CA",
  "property_seo_description_faqs": "Find answers to your questions about Corn Dog Manufacturer in Livingston, CA. From studio layouts to parking perks, we’ve got you covered. FAQs await!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Livingston, CA",
  "property_seo_description_reviews": "Discover life at Corn Dog Manufacturer in Livingston, CA! Check resident reviews and see why our wheelchair-accessible community is ideal for you.",
  "property_seo_title_applynow": "Apply Now | Apartments in Livingston, CA",
  "property_seo_description_applynow": "Discover comfort at Corn Dog Manufacturer in Livingston, CA! Wheelchair-accessible studio living with free parking. Apply online now!",
  "property_seo_title_residentaccess": "Resident Access | Corn Dog Manufacturer",
  "property_seo_description_residentaccess": "Access your Corn Dog Manufacturer resident portal in Livingston, CA—pay rent, schedule maintenance, and enjoy community perks, all at your fingertips!",
  "property_seo_title_referafriend": "Refer A Friend | Corn Dog Manufacturer",
  "property_seo_description_referafriend": "Share the love! Refer a friend to Corn Dog Manufacturer in Livingston, CA, and build a tight-knit community where great friendships thrive.",
  "property_seo_title_scheduletour": "Schedule a Tour | Corn Dog Manufacturer",
  "property_seo_description_scheduletour": "Experience vibrant living at Corn Dog Manufacturer in Livingston, CA. Schedule a tour today and see why our community is the perfect place to call home!",
  "property_seo_title_privacy": "Privacy Policy | Corn Dog Manufacturer",
  "property_seo_description_privacy": "At Corn Dog Manufacturer in Livingston, CA, your privacy is our priority. Discover how we protect your information in our privacy policy.",
  "property_seo_title_accessibility": "Website Accessibility | Corn Dog Manufacturer",
  "property_seo_description_accessibility": "At Corn Dog Manufacturer in Livingston, CA, we champion digital inclusion! Explore our commitment to accessibility and ensure everyone feels at home.",
  "property_seo_title_sitemap": "Sitemap | Corn Dog Manufacturer",
  "property_seo_description_sitemap": "Navigate your way through the Corn Dog Manufacturer community in Livingston, CA. Find detailed info on amenities, floor plans, and more in our sitemap!",
  "property_seo_title_thankyou": "Thank You | Corn Dog Manufacturer",
  "property_seo_description_thankyou": "Thank you for reaching out to Corn Dog Manufacturer in Livingston, CA! Your inquiry is valued, and our team will connect with you soon to assist you further.",
  "property_seo_title_pets": "Pet Policy | Apartments in Livingston, CA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1784073214288",
  "amenities": [
    {
      "id": "false",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "external_id": "false",
      "title": "Wheelchair accessible",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "false",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "external_id": "false",
      "title": "Parking: Lot, Free",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "false",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-e6fa-7404-adf1-9d01f32a6f36.webp",
      "image_media": {
        "alt_text": "Foster Farms logo with a rooster and yellow background",
        "public_id": "019f630a-e6fa-7404-adf1-9d01f32a6f36",
        "storage_key": "property/6767906449167478/019f630a-e6fa-7404-adf1-9d01f32a6f36.webp",
        "width": 346,
        "height": 321
      },
      "title": "Logo",
      "description": "Foster Farms logo",
      "link": "false",
      "alt_text": "Foster Farms logo",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://www.fosterfarms.com/app/themes/fosterfarms/public/build/assets/logo-MM8dgsXp.svg"
    },
    {
      "id": "false",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-e606-7348-9fb1-bfd17dbb02f8.webp",
      "image_media": {
        "alt_text": "Foster Farms chicken thighs with a prepared dish of chicken and vegetables.",
        "public_id": "019f630a-e606-7348-9fb1-bfd17dbb02f8",
        "storage_key": "property/6767906449167478/019f630a-e606-7348-9fb1-bfd17dbb02f8.webp",
        "width": 1536,
        "height": 2160
      },
      "title": "Other",
      "description": "A serving dish of chicken and vegetables sits next to a package of Foster Farms chicken thighs.",
      "link": "false",
      "alt_text": "Foster Farms chicken thighs with a prepared dish of chicken and vegetables.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://www.fosterfarms.com/app/uploads/Homepage-Masthead_Main_Mobile.jpg"
    },
    {
      "id": "false",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-e854-75ea-be17-ab8dd5187e19.webp",
      "image_media": {
        "alt_text": "Foster Farms chicken thighs and a skillet of chicken dish",
        "public_id": "019f630a-e854-75ea-be17-ab8dd5187e19",
        "storage_key": "property/6767906449167478/019f630a-e854-75ea-be17-ab8dd5187e19.webp",
        "width": 2560,
        "height": 1067
      },
      "title": "Other",
      "description": "Fresh and natural chicken thighs from Foster Farms, perfect for creating delicious meals like this skillet dish.",
      "link": "false",
      "alt_text": "Foster Farms chicken thighs and a skillet of chicken dish",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://www.fosterfarms.com/app/uploads/Homepage-Masthead_Main_Desktop-scaled.jpg"
    },
    {
      "id": "false",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-e62c-759d-8ae8-4a4c15953042.webp",
      "image_media": {
        "alt_text": "Foster Farms High Protein chicken breast bites with 20g protein per serving",
        "public_id": "019f630a-e62c-759d-8ae8-4a4c15953042",
        "storage_key": "property/6767906449167478/019f630a-e62c-759d-8ae8-4a4c15953042.webp",
        "width": 1536,
        "height": 2160
      },
      "title": "Other",
      "description": "Foster Farms High Protein lightly breaded chicken breast bites are great for snacking and offer 20g of protein per serving. They are 100% all-natural, with no antibiotics ever, and zero sugar.",
      "link": "false",
      "alt_text": "Foster Farms High Protein chicken breast bites with 20g protein per serving",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://www.fosterfarms.com/app/uploads/Homepage-Masthead_High-Protein-Bites_Mobile-2.jpg"
    },
    {
      "id": "false",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-e7ed-76aa-857c-a2c0d824141f.webp",
      "image_media": {
        "alt_text": "Foster Farms High Protein Lightly Breaded Chicken Breast Bites packaging with floating chicken pieces",
        "public_id": "019f630a-e7ed-76aa-857c-a2c0d824141f",
        "storage_key": "property/6767906449167478/019f630a-e7ed-76aa-857c-a2c0d824141f.webp",
        "width": 2560,
        "height": 1067
      },
      "title": "Other",
      "description": "Foster Farms High Protein Lightly Breaded Chicken Breast Bites. 20g protein per serving. Great for snacking.",
      "link": "false",
      "alt_text": "Foster Farms High Protein Lightly Breaded Chicken Breast Bites packaging with floating chicken pieces",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://www.fosterfarms.com/app/uploads/Homepage-Masthead_High-Protein-Bites_Desktop-R2-1-scaled.jpg"
    },
    {
      "id": "false",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-e62d-70cd-bf33-d2747e999891.webp",
      "image_media": {
        "alt_text": "Foster Farms Crispy Bites Mild Buffalo Style",
        "public_id": "019f630a-e62d-70cd-bf33-d2747e999891",
        "storage_key": "property/6767906449167478/019f630a-e62d-70cd-bf33-d2747e999891.webp",
        "width": 1536,
        "height": 2160
      },
      "title": "Other",
      "description": "Foster Farms Crispy Bites Mild Buffalo Style: breaded boneless skinless chicken breast portions with sauce packet included.",
      "link": "false",
      "alt_text": "Foster Farms Crispy Bites Mild Buffalo Style",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://www.fosterfarms.com/app/uploads/Homepage-Masthead_TO-Crispy-Bites_Mobile.jpg"
    },
    {
      "id": "false",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-e85d-743f-ab44-16119ac65624.webp",
      "image_media": {
        "alt_text": "Foster Farms Crispy Bites Mild Buffalo style chicken breast portions in a bowl with sauce and product packaging.",
        "public_id": "019f630a-e85d-743f-ab44-16119ac65624",
        "storage_key": "property/6767906449167478/019f630a-e85d-743f-ab44-16119ac65624.webp",
        "width": 2560,
        "height": 1067
      },
      "title": "Other",
      "description": "Enjoy Foster Farms Crispy Bites in Mild Buffalo flavor. Lightly breaded chicken breast portions, ready in minutes. 13g of protein per serving. Sauce packet included.",
      "link": "false",
      "alt_text": "Foster Farms Crispy Bites Mild Buffalo style chicken breast portions in a bowl with sauce and product packaging.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://www.fosterfarms.com/app/uploads/Homepage-Masthead_TO-Crispy-Bites_Desktop-scaled.jpg"
    },
    {
      "id": "false",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-e656-71ff-bee6-0dd67554eea9.webp",
      "image_media": {
        "alt_text": "Shopping basket filled with Foster Farms corn dogs, crispy wings, and organic chicken.",
        "public_id": "019f630a-e656-71ff-bee6-0dd67554eea9",
        "storage_key": "property/6767906449167478/019f630a-e656-71ff-bee6-0dd67554eea9.webp",
        "width": 768,
        "height": 1080
      },
      "title": "Other",
      "description": "A shopping basket overflowing with a variety of Foster Farms products, including corn dogs, crispy wings, and organic chicken breast. Perfect for a quick and easy meal.",
      "link": "false",
      "alt_text": "Shopping basket filled with Foster Farms corn dogs, crispy wings, and organic chicken.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://www.fosterfarms.com/app/uploads/Homepage-Masthead_Where-to-Buy_Mobile-1.jpg"
    },
    {
      "id": "false",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-e85d-743f-ab44-1364ad0e5242.webp",
      "image_media": {
        "alt_text": "Foster Farms grocery basket filled with corn dogs, crispy wings, and organic chicken.",
        "public_id": "019f630a-e85d-743f-ab44-1364ad0e5242",
        "storage_key": "property/6767906449167478/019f630a-e85d-743f-ab44-1364ad0e5242.webp",
        "width": 2560,
        "height": 1067
      },
      "title": "Other",
      "description": "A metal grocery basket overflowing with Foster Farms products including corn dogs, crispy chicken wings, and organic chicken breasts, set against a bright yellow background.",
      "link": "false",
      "alt_text": "Foster Farms grocery basket filled with corn dogs, crispy wings, and organic chicken.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://www.fosterfarms.com/app/uploads/Homepage-Masthead_Where-to-Buy_Desktop-1-scaled.jpg"
    },
    {
      "id": "false",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-e751-75b9-a008-4c28590b9cec.webp",
      "image_media": {
        "alt_text": "Foster Farms chicken packages",
        "public_id": "019f630a-e751-75b9-a008-4c28590b9cec",
        "storage_key": "property/6767906449167478/019f630a-e751-75b9-a008-4c28590b9cec.webp",
        "width": 300,
        "height": 200
      },
      "title": "Other",
      "description": "FRESH CHICKEN",
      "link": "false",
      "alt_text": "FRESH CHICKEN",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://www.fosterfarms.com/app/uploads/Homepage_RTC-Group-Pack-Shots-300x200.png"
    },
    {
      "id": "false",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-f112-70d8-9f75-d4807cd138e9.webp",
      "image_media": {
        "alt_text": "Two bags of Foster Farms crispy strips and breast nuggets.",
        "public_id": "019f630a-f112-70d8-9f75-d4807cd138e9",
        "storage_key": "property/6767906449167478/019f630a-f112-70d8-9f75-d4807cd138e9.webp",
        "width": 300,
        "height": 200
      },
      "title": "Other",
      "description": "FROZEN CHICKEN",
      "link": "false",
      "alt_text": "FROZEN CHICKEN",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://www.fosterfarms.com/app/uploads/Homepage_FCC-Group-Pack-Shots-300x200.png"
    },
    {
      "id": "false",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-f117-74da-9672-ce3329f6fc02.webp",
      "image_media": {
        "alt_text": "Two bags of Foster Farms Crispy Bites and Crispy Wings",
        "public_id": "019f630a-f117-74da-9672-ce3329f6fc02",
        "storage_key": "property/6767906449167478/019f630a-f117-74da-9672-ce3329f6fc02.webp",
        "width": 300,
        "height": 200
      },
      "title": "Other",
      "description": "TAKE OUT",
      "link": "false",
      "alt_text": "TAKE OUT",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://www.fosterfarms.com/app/uploads/Homepage_Take-Out-Group-Pack-Shots-1-300x200.png"
    },
    {
      "id": "false",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-f193-7592-b663-9ff6bff87d8c.webp",
      "image_media": {
        "alt_text": "Foster Farms Corn Dogs and Mini Corn Dogs packaging",
        "public_id": "019f630a-f193-7592-b663-9ff6bff87d8c",
        "storage_key": "property/6767906449167478/019f630a-f193-7592-b663-9ff6bff87d8c.webp",
        "width": 300,
        "height": 200
      },
      "title": "Other",
      "description": "CORN DOGS",
      "link": "false",
      "alt_text": "CORN DOGS",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://www.fosterfarms.com/app/uploads/Homepage_CD-Group-Pack-Shots-300x200.png"
    },
    {
      "id": "false",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-f17a-7328-aab1-8f1c257cf11e.webp",
      "image_media": {
        "alt_text": "Foster Farms Grilled Strips Honey Roasted and Classic variety packages",
        "public_id": "019f630a-f17a-7328-aab1-8f1c257cf11e",
        "storage_key": "property/6767906449167478/019f630a-f17a-7328-aab1-8f1c257cf11e.webp",
        "width": 300,
        "height": 200
      },
      "title": "Other",
      "description": "REFRIGERATED CHICKEN",
      "link": "false",
      "alt_text": "REFRIGERATED CHICKEN",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://www.fosterfarms.com/app/uploads/Homepage_RCC-Group-Pack-Shots-300x200.png"
    },
    {
      "id": "false",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-f1ac-76d0-a0d6-4562bd43c82f.webp",
      "image_media": {
        "alt_text": "Foster Farms Turkey Breast and Chicken Franks products.",
        "public_id": "019f630a-f1ac-76d0-a0d6-4562bd43c82f",
        "storage_key": "property/6767906449167478/019f630a-f1ac-76d0-a0d6-4562bd43c82f.webp",
        "width": 300,
        "height": 200
      },
      "title": "Other",
      "description": "FRANKS & DELI",
      "link": "false",
      "alt_text": "FRANKS & DELI",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://www.fosterfarms.com/app/uploads/Homepage_LM-Franks-Group-Packshots-300x200.png"
    },
    {
      "id": "false",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-f0f1-768b-8fa0-a3c0aff16b49.webp",
      "image_media": {
        "alt_text": "Foster Farms Take Out Crispy Wings Classic Buffalo Style",
        "public_id": "019f630a-f0f1-768b-8fa0-a3c0aff16b49",
        "storage_key": "property/6767906449167478/019f630a-f0f1-768b-8fa0-a3c0aff16b49.webp",
        "width": 400,
        "height": 400
      },
      "title": "Other",
      "description": "Take Out Classic Buffalo Crispy Chicken Wings",
      "link": "false",
      "alt_text": "Take Out Classic Buffalo Crispy Chicken Wings",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://www.fosterfarms.com/app/uploads/TO-Crispy-Wings-400x400-1.png"
    },
    {
      "id": "false",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-f0e5-77a9-a94f-b681fd8f6e7c.webp",
      "image_media": {
        "alt_text": "Foster Farms value pack of classic chicken breast nuggets with ketchup and grapes.",
        "public_id": "019f630a-f0e5-77a9-a94f-b681fd8f6e7c",
        "storage_key": "property/6767906449167478/019f630a-f0e5-77a9-a94f-b681fd8f6e7c.webp",
        "width": 400,
        "height": 400
      },
      "title": "Other",
      "description": "Foster Farms Chicken Nuggets",
      "link": "false",
      "alt_text": "Foster Farms Chicken Nuggets",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://www.fosterfarms.com/app/uploads/Breast-Nuggets-400x400-1.png"
    },
    {
      "id": "false",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-f175-72ee-b676-6e1f1da65147.webp",
      "image_media": {
        "alt_text": "Foster Farms Free Range Thin-Sliced Chicken Breast Fillets",
        "public_id": "019f630a-f175-72ee-b676-6e1f1da65147",
        "storage_key": "property/6767906449167478/019f630a-f175-72ee-b676-6e1f1da65147.webp",
        "width": 400,
        "height": 400
      },
      "title": "Other",
      "description": "Foster Farms Free Range Chicken Breast",
      "link": "false",
      "alt_text": "Foster Farms Free Range Chicken Breast",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://www.fosterfarms.com/app/uploads/Simply-Raised-400x400-1.png"
    },
    {
      "id": "false",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-f181-772f-86fb-f21745ddd1ba.webp",
      "image_media": {
        "alt_text": "Foster Farms Crispy Strips bag with fried chicken strips and dipping sauce",
        "public_id": "019f630a-f181-772f-86fb-f21745ddd1ba",
        "storage_key": "property/6767906449167478/019f630a-f181-772f-86fb-f21745ddd1ba.webp",
        "width": 400,
        "height": 400
      },
      "title": "Other",
      "description": "Foster Farms Crispy Strips",
      "link": "false",
      "alt_text": "Foster Farms Crispy Strips",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://www.fosterfarms.com/app/uploads/Crispy-Strips-400x400-1.png"
    },
    {
      "id": "false",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-f84d-70db-9811-13484009e836.webp",
      "image_media": {
        "alt_text": "Barcode",
        "public_id": "019f630a-f84d-70db-9811-13484009e836",
        "storage_key": "property/6767906449167478/019f630a-f84d-70db-9811-13484009e836.webp",
        "width": 800,
        "height": 550
      },
      "title": "Other",
      "description": "Barcode image for product identification.",
      "link": "false",
      "alt_text": "Barcode",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://www.fosterfarms.com/app/themes/fosterfarms/public/build/assets/Barcode-D3qG1h7w.png"
    },
    {
      "id": "false",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-f8fe-77ca-bcc1-5a59aaebe1db.webp",
      "image_media": {
        "alt_text": "Product batch code and best by date",
        "public_id": "019f630a-f8fe-77ca-bcc1-5a59aaebe1db",
        "storage_key": "property/6767906449167478/019f630a-f8fe-77ca-bcc1-5a59aaebe1db.webp",
        "width": 700,
        "height": 300
      },
      "title": "Other",
      "description": "This image shows a product batch code P-20923 and best by date 12/18/21.",
      "link": "false",
      "alt_text": "Product batch code and best by date",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://www.fosterfarms.com/app/themes/fosterfarms/public/build/assets/FCC_Date_Code-BIDy-jhz.png"
    },
    {
      "id": "false",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-f9ad-7511-b7b6-f33e837783a2.webp",
      "image_media": {
        "alt_text": "Best if used by May 10 2023, batch number 213917, P-33901",
        "public_id": "019f630a-f9ad-7511-b7b6-f33e837783a2",
        "storage_key": "property/6767906449167478/019f630a-f9ad-7511-b7b6-f33e837783a2.webp",
        "width": 190,
        "height": 87
      },
      "title": "Other",
      "description": "This image displays a \"Best if Used By\" date of May 10, 2023, along with batch and product codes.",
      "link": "false",
      "alt_text": "Best if used by May 10 2023, batch number 213917, P-33901",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://www.fosterfarms.com/app/themes/fosterfarms/public/build/assets/FCC_MANU_CODE_2-CLZFI-Ap.png"
    },
    {
      "id": "false",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-f9a7-75e4-b8d4-cc188dfe3235.webp",
      "image_media": {
        "alt_text": "Best By Date 01/20/24",
        "public_id": "019f630a-f9a7-75e4-b8d4-cc188dfe3235",
        "storage_key": "property/6767906449167478/019f630a-f9a7-75e4-b8d4-cc188dfe3235.webp",
        "width": 240,
        "height": 97
      },
      "title": "Other",
      "description": "Expiration date information for a product.",
      "link": "false",
      "alt_text": "Best By Date 01/20/24",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://www.fosterfarms.com/app/themes/fosterfarms/public/build/assets/FFC_MANU_CODE-DXdO0J4I.png"
    },
    {
      "id": "false",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-f9fb-74f4-98b4-88ee4bb2d3c8.webp",
      "image_media": {
        "alt_text": "Best by date 12/18/21",
        "public_id": "019f630a-f9fb-74f4-98b4-88ee4bb2d3c8",
        "storage_key": "property/6767906449167478/019f630a-f9fb-74f4-98b4-88ee4bb2d3c8.webp",
        "width": 700,
        "height": 300
      },
      "title": "Other",
      "description": "Label indicating the best by date of 12/18/21, with additional codes P-20923 and 2B035311:24.",
      "link": "false",
      "alt_text": "Best by date 12/18/21",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://www.fosterfarms.com/app/themes/fosterfarms/public/build/assets/FCC_Date-DjeoLsm5.png"
    },
    {
      "id": "false",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-f992-742b-8370-c651333bdfe2.webp",
      "image_media": {
        "alt_text": "An upward-pointing arrow inside a circle.",
        "public_id": "019f630a-f992-742b-8370-c651333bdfe2",
        "storage_key": "property/6767906449167478/019f630a-f992-742b-8370-c651333bdfe2.webp",
        "width": 3072,
        "height": 3072
      },
      "title": "Other",
      "description": "file upload icon",
      "link": "false",
      "alt_text": "file upload icon",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://www.svgrepo.com/show/485545/upload-cicle.svg"
    },
    {
      "id": "false",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630b-015b-7136-afa9-ca2344ca284c.webp",
      "image_media": {
        "alt_text": "Foster Farms Boneless Wyngz Buffalo Style Glazed Chicken Breast with Rib Meat Fritters package.",
        "public_id": "019f630b-015b-7136-afa9-ca2344ca284c",
        "storage_key": "property/6767906449167478/019f630b-015b-7136-afa9-ca2344ca284c.webp",
        "width": 800,
        "height": 700
      },
      "title": "Other",
      "description": "Buffalo Style Boneless Chicken Wyngz, Frozen - 24 oz",
      "link": "false",
      "alt_text": "Buffalo Style Boneless Chicken Wyngz, Frozen - 24 oz",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://www.fosterfarms.com/app/uploads/99544-451194-FCC-NAE-BNLSSWYNGZ-BFFLSTYL-24oz_T.png"
    },
    {
      "id": "false",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630b-0198-7226-801b-0578642d204a.webp",
      "image_media": {
        "alt_text": "Foster Farms Chicken Franks package with hot dog and mustard.",
        "public_id": "019f630b-0198-7226-801b-0578642d204a",
        "storage_key": "property/6767906449167478/019f630b-0198-7226-801b-0578642d204a.webp",
        "width": 800,
        "height": 700
      },
      "title": "Other",
      "description": "Chicken Franks, Refrigerated - 16 oz",
      "link": "false",
      "alt_text": "Chicken Franks, Refrigerated - 16 oz",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://www.fosterfarms.com/app/uploads/11010-11014-451234-FRNKS-CHKN-8ct-16oz_T.png"
    },
    {
      "id": "false",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630b-02ee-75fc-9541-1cb42e64b5fa.webp",
      "image_media": {
        "alt_text": "Foster Farms Chicken Franks packaging",
        "public_id": "019f630b-02ee-75fc-9541-1cb42e64b5fa",
        "storage_key": "property/6767906449167478/019f630b-02ee-75fc-9541-1cb42e64b5fa.webp",
        "width": 800,
        "height": 700
      },
      "title": "Other",
      "description": "Chicken Franks, Refrigerated - 48 oz",
      "link": "false",
      "alt_text": "Chicken Franks, Refrigerated - 48 oz",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://www.fosterfarms.com/app/uploads/11060-451238-FRNKS-CHKN-24ct-48oz_T.png"
    },
    {
      "id": "false",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630b-04fa-728c-8b0c-e5a4b4673f8c.webp",
      "image_media": {
        "alt_text": "Bag of Foster Farms Classic Breast Nuggets with ketchup and grapes.",
        "public_id": "019f630b-04fa-728c-8b0c-e5a4b4673f8c",
        "storage_key": "property/6767906449167478/019f630b-04fa-728c-8b0c-e5a4b4673f8c.webp",
        "width": 2400,
        "height": 2400
      },
      "title": "Other",
      "description": "Chicken Nuggets Family Pack, Frozen - 64 oz",
      "link": "false",
      "alt_text": "Chicken Nuggets Family Pack, Frozen - 64 oz",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://www.fosterfarms.com/app/uploads/00075278996423_3DFront.jpg"
    },
    {
      "id": "false",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630b-05c1-71c0-8296-e5fb8351f18d.webp",
      "image_media": {
        "alt_text": "Foster Farms value pack of chicken breast nuggets with ketchup and grapes.",
        "public_id": "019f630b-05c1-71c0-8296-e5fb8351f18d",
        "storage_key": "property/6767906449167478/019f630b-05c1-71c0-8296-e5fb8351f18d.webp",
        "width": 800,
        "height": 700
      },
      "title": "Other",
      "description": "Chicken Nuggets, Frozen - 33.6 oz",
      "link": "false",
      "alt_text": "Chicken Nuggets, Frozen - 33.6 oz",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://www.fosterfarms.com/app/uploads/99549-451201-FCC-BRSTNGGTS-VLPK-33oz_T.png"
    },
    {
      "id": "false",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630b-0bad-7721-96fb-4ddea0715ca3.webp",
      "image_media": {
        "alt_text": "Foster Farms chicken patties bag with a chicken and pickle burger.",
        "public_id": "019f630b-0bad-7721-96fb-4ddea0715ca3",
        "storage_key": "property/6767906449167478/019f630b-0bad-7721-96fb-4ddea0715ca3.webp",
        "width": 800,
        "height": 700
      },
      "title": "Other",
      "description": "Chicken Patties Family Pack, Frozen - 80 oz",
      "link": "false",
      "alt_text": "Chicken Patties Family Pack, Frozen - 80 oz",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://www.fosterfarms.com/app/uploads/99724-451195-FCC-COSTCO-NAE-CHCKNPTTS-80oz_T.png"
    },
    {
      "id": "false",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630b-0ba3-71af-9060-fff5ba4373ec.webp",
      "image_media": {
        "alt_text": "Foster Farms Classic Chicken Patties value pack",
        "public_id": "019f630b-0ba3-71af-9060-fff5ba4373ec",
        "storage_key": "property/6767906449167478/019f630b-0ba3-71af-9060-fff5ba4373ec.webp",
        "width": 800,
        "height": 700
      },
      "title": "Other",
      "description": "Chicken Patties, Frozen - 28 oz",
      "link": "false",
      "alt_text": "Chicken Patties, Frozen - 28 oz",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://www.fosterfarms.com/app/uploads/99548-451200-FCC-CHCKNPTTS-VLPK-28oz_T.png"
    },
    {
      "id": "false",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630b-0eb7-74f2-b985-ea4f5750c2ad.webp",
      "image_media": {
        "alt_text": "Foster Farms Crispy Strips chicken breast fritters with rib meat packaging with cooked chicken strips.",
        "public_id": "019f630b-0eb7-74f2-b985-ea4f5750c2ad",
        "storage_key": "property/6767906449167478/019f630b-0eb7-74f2-b985-ea4f5750c2ad.webp",
        "width": 800,
        "height": 700
      },
      "title": "Other",
      "description": "Crispy Chicken Strips, Frozen - 24 oz",
      "link": "false",
      "alt_text": "Crispy Chicken Strips, Frozen - 24 oz",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://www.fosterfarms.com/app/uploads/90974-458201-FCC-NAE-CRSPYSTRPS-24oz_T-1.png"
    },
    {
      "id": "false",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630b-14ba-7601-8d2c-9002c84ed672.webp",
      "image_media": {
        "alt_text": "Foster Farms Dino Nuggets bag with cartoon dinosaurs and chicken nuggets shaped like dinosaurs.",
        "public_id": "019f630b-14ba-7601-8d2c-9002c84ed672",
        "storage_key": "property/6767906449167478/019f630b-14ba-7601-8d2c-9002c84ed672.webp",
        "width": 2400,
        "height": 2400
      },
      "title": "Other",
      "description": "Dino Chicken Nuggets, Frozen - 28 oz",
      "link": "false",
      "alt_text": "Dino Chicken Nuggets, Frozen - 28 oz",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://www.fosterfarms.com/app/uploads/00075278996430_3DFront.jpg"
    },
    {
      "id": "false",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630b-13f9-7308-bd12-066132f0a752.webp",
      "image_media": {
        "alt_text": "Bag of Foster Farms Crispy Strips Buffalo Style chicken breast fritters.",
        "public_id": "019f630b-13f9-7308-bd12-066132f0a752",
        "storage_key": "property/6767906449167478/019f630b-13f9-7308-bd12-066132f0a752.webp",
        "width": 800,
        "height": 700
      },
      "title": "Other",
      "description": "Foster Farms Buffalo Style Crispy Chicken Strips, Frozen - 24 oz",
      "link": "false",
      "alt_text": "Foster Farms Buffalo Style Crispy Chicken Strips, Frozen - 24 oz",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://www.fosterfarms.com/app/uploads/90973-451199-FCC-NAE-CRSPYSTRPS-BFFLSTYL-24oz_T.png"
    },
    {
      "id": "false",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630b-1405-761a-ada1-8763d9ae30bc.webp",
      "image_media": {
        "alt_text": "Foster Farms High Protein Lightly Breaded Chicken Breast Bites packaging",
        "public_id": "019f630b-1405-761a-ada1-8763d9ae30bc",
        "storage_key": "property/6767906449167478/019f630b-1405-761a-ada1-8763d9ae30bc.webp",
        "width": 800,
        "height": 700
      },
      "title": "Other",
      "description": "Foster Farms Lightly Breaded High Protein Bites, Frozen - 20 oz",
      "link": "false",
      "alt_text": "Foster Farms Lightly Breaded High Protein Bites, Frozen - 20 oz",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://www.fosterfarms.com/app/uploads/99014-405906-FCC-High-Protein-Bites-20oz_T.png"
    },
    {
      "id": "false",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630b-17c4-706e-960c-6e00feb089b7.webp",
      "image_media": {
        "alt_text": "Foster Farms Free Range Chicken Breast Fillets packaging",
        "public_id": "019f630b-17c4-706e-960c-6e00feb089b7",
        "storage_key": "property/6767906449167478/019f630b-17c4-706e-960c-6e00feb089b7.webp",
        "width": 800,
        "height": 700
      },
      "title": "Other",
      "description": "Free Range Boneless Skinless Chicken Breast Fillets",
      "link": "false",
      "alt_text": "Free Range Boneless Skinless Chicken Breast Fillets",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://www.fosterfarms.com/app/uploads/3431-3421-451092-RTC-SR-BRSTFLLTSBLSL-3DPET_T-1.png"
    },
    {
      "id": "false",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630b-1bf8-76b9-ad26-17e3ede54826.webp",
      "image_media": {
        "alt_text": "Foster Farms Free Range chicken breast tenders, air chilled, no antibiotics, vegetarian fed, no hormones or steroids.",
        "public_id": "019f630b-1bf8-76b9-ad26-17e3ede54826",
        "storage_key": "property/6767906449167478/019f630b-1bf8-76b9-ad26-17e3ede54826.webp",
        "width": 800,
        "height": 700
      },
      "title": "Other",
      "description": "Free Range Boneless Skinless Chicken Breast Tenders",
      "link": "false",
      "alt_text": "Free Range Boneless Skinless Chicken Breast Tenders",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://www.fosterfarms.com/app/uploads/3438-3455-451100-RTC-SR-BRSTTNDRSBLSL-3SPET_T.png"
    },
    {
      "id": "false",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630b-1e92-764c-99a9-846b9d216219.webp",
      "image_media": {
        "alt_text": "Foster Farms Free Range Thigh Fillets",
        "public_id": "019f630b-1e92-764c-99a9-846b9d216219",
        "storage_key": "property/6767906449167478/019f630b-1e92-764c-99a9-846b9d216219.webp",
        "width": 800,
        "height": 700
      },
      "title": "Other",
      "description": "Free Range Boneless Skinless Chicken Thigh Fillets",
      "link": "false",
      "alt_text": "Free Range Boneless Skinless Chicken Thigh Fillets",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://www.fosterfarms.com/app/uploads/3442-451110-RTC-SR-THGHFLLTS-BLSL-3SPET_T.png"
    },
    {
      "id": "false",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630b-1eb0-7065-84a2-64164916b278.webp",
      "image_media": {
        "alt_text": "Foster Farms Free Range Chicken Drumsticks",
        "public_id": "019f630b-1eb0-7065-84a2-64164916b278",
        "storage_key": "property/6767906449167478/019f630b-1eb0-7065-84a2-64164916b278.webp",
        "width": 800,
        "height": 700
      },
      "title": "Other",
      "description": "Free Range Chicken Drumsticks",
      "link": "false",
      "alt_text": "Free Range Chicken Drumsticks",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://www.fosterfarms.com/app/uploads/3433-3451-451098-RTC-SR-DRMSTCKS-3DPET_T.png"
    },
    {
      "id": "false",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630b-1e64-74db-bc83-b93b8988623d.webp",
      "image_media": {
        "alt_text": "Foster Farms Free Range Chicken Thighs",
        "public_id": "019f630b-1e64-74db-bc83-b93b8988623d",
        "storage_key": "property/6767906449167478/019f630b-1e64-74db-bc83-b93b8988623d.webp",
        "width": 800,
        "height": 700
      },
      "title": "Other",
      "description": "Free Range Chicken Thighs",
      "link": "false",
      "alt_text": "Free Range Chicken Thighs",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://www.fosterfarms.com/app/uploads/3432-3450-451096-RTC-SR-THGHS-3DPET_T.png"
    },
    {
      "id": "false",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630b-1ece-706d-b3ed-2c438929e8c1.webp",
      "image_media": {
        "alt_text": "Foster Farms Free Range Chicken Wings package",
        "public_id": "019f630b-1ece-706d-b3ed-2c438929e8c1",
        "storage_key": "property/6767906449167478/019f630b-1ece-706d-b3ed-2c438929e8c1.webp",
        "width": 800,
        "height": 700
      },
      "title": "Other",
      "description": "Free Range Chicken Wings",
      "link": "false",
      "alt_text": "Free Range Chicken Wings",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://www.fosterfarms.com/app/uploads/3443-3453-470494-RTC-SR-WNGS-3DPET_T.png"
    },
    {
      "id": "false",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630b-259a-75b6-b9ab-b58be2ec85da.webp",
      "image_media": {
        "alt_text": "Foster Farms Free Range Chicken Half Breasts",
        "public_id": "019f630b-259a-75b6-b9ab-b58be2ec85da",
        "storage_key": "property/6767906449167478/019f630b-259a-75b6-b9ab-b58be2ec85da.webp",
        "width": 800,
        "height": 700
      },
      "title": "Other",
      "description": "Free Range Half Chicken Breasts",
      "link": "false",
      "alt_text": "Free Range Half Chicken Breasts",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://www.fosterfarms.com/app/uploads/3440-3452-451102-RTC-SR-HLFBRSTSWR-3DPET_T.png"
    },
    {
      "id": "false",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630b-26c5-715e-999c-f850fd595ed2.webp",
      "image_media": {
        "alt_text": "Foster Farms Free Range Party Wings",
        "public_id": "019f630b-26c5-715e-999c-f850fd595ed2",
        "storage_key": "property/6767906449167478/019f630b-26c5-715e-999c-f850fd595ed2.webp",
        "width": 800,
        "height": 700
      },
      "title": "Other",
      "description": "Free Range Party Chicken Wings",
      "link": "false",
      "alt_text": "Free Range Party Chicken Wings",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://www.fosterfarms.com/app/uploads/3441-3460-451106-RTC-SR-PRTYWNGS-3SPET_T.png"
    },
    {
      "id": "false",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630b-2766-7692-8eae-08731a21083d.webp",
      "image_media": {
        "alt_text": "Foster Farms Free Range Thin-Sliced Breast Fillets",
        "public_id": "019f630b-2766-7692-8eae-08731a21083d",
        "storage_key": "property/6767906449167478/019f630b-2766-7692-8eae-08731a21083d.webp",
        "width": 800,
        "height": 700
      },
      "title": "Other",
      "description": "Free Range Thin-Sliced Boneless Skinless Chicken Breast Fillets",
      "link": "false",
      "alt_text": "Free Range Thin-Sliced Boneless Skinless Chicken Breast Fillets",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://www.fosterfarms.com/app/uploads/3430-3454-451094-RTC-SR-THNSLCDBRSTFLLTSBLSL-3SPET_T.png"
    },
    {
      "id": "false",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630b-268a-701f-b40a-45174d8e06d6.webp",
      "image_media": {
        "alt_text": "Foster Farms Fresh & Natural Cage Free Boneless Skinless Chicken Breast Fillets",
        "public_id": "019f630b-268a-701f-b40a-45174d8e06d6",
        "storage_key": "property/6767906449167478/019f630b-268a-701f-b40a-45174d8e06d6.webp",
        "width": 800,
        "height": 700
      },
      "title": "Other",
      "description": "Fresh & Natural Boneless Skinless Chicken Breast Fillets",
      "link": "false",
      "alt_text": "Fresh & Natural Boneless Skinless Chicken Breast Fillets",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://www.fosterfarms.com/app/uploads/827-7563-450941-RTC-CON-BRSTFLLTSWRM-3P_T.png"
    },
    {
      "id": "false",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630b-29ae-7180-baf3-5588dbda2b51.webp",
      "image_media": {
        "alt_text": "Foster Farms Fresh & Natural Cage Free chicken breast fillets in yellow packaging",
        "public_id": "019f630b-29ae-7180-baf3-5588dbda2b51",
        "storage_key": "property/6767906449167478/019f630b-29ae-7180-baf3-5588dbda2b51.webp",
        "width": 800,
        "height": 700
      },
      "title": "Other",
      "description": "Fresh & Natural Boneless Skinless Chicken Breasts Family Pack",
      "link": "false",
      "alt_text": "Fresh & Natural Boneless Skinless Chicken Breasts Family Pack",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://www.fosterfarms.com/app/uploads/957-72615-73877-78615-450945-RTC-CON-BRSTFLLTSWRM-7D_T.png"
    },
    {
      "id": "false",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630b-2f09-75e5-a32b-18c012dcca1e.webp",
      "image_media": {
        "alt_text": "Foster Farms Fresh & Natural boneless, skinless chicken thigh fillets in a yellow package.",
        "public_id": "019f630b-2f09-75e5-a32b-18c012dcca1e",
        "storage_key": "property/6767906449167478/019f630b-2f09-75e5-a32b-18c012dcca1e.webp",
        "width": 800,
        "height": 700
      },
      "title": "Other",
      "description": "Fresh & Natural Boneless Skinless Chicken Thigh Fillets",
      "link": "false",
      "alt_text": "Fresh & Natural Boneless Skinless Chicken Thigh Fillets",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://www.fosterfarms.com/app/uploads/578-7571-865-450963-RTC-CON-THGHFLLTSBLSL-2P_T-1.png"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "false",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "poi_name": "Foster Farms Livingston Cafe",
      "poi_type": "Restaurants",
      "poi_address": "221 Stefani Ave, Livingston, CA 95334, USA",
      "poi_short_description": "Casual roadside eatery, known for all-you-can-eat chicken nights, serving comfort food and fried chicken.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-40e6-74d1-900d-5f3744029199.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f630a-40e6-74d1-900d-5f3744029199",
        "storage_key": "property/6767906449167478/019f630a-40e6-74d1-900d-5f3744029199.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=6654757961431723551&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "foster-farms-livingston-cafe",
      "poi_latitude": "37.3895777",
      "poi_longitude": "-120.7240044",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 209-394-7950",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-7636-706b-a04a-89d939f18bbd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f630a-7636-706b-a04a-89d939f18bbd",
        "storage_key": "property/6767906449167478/019f630a-7636-706b-a04a-89d939f18bbd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ0CXhXcNkYARHy5XhRtzWlw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "false",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "poi_name": "Villa's Mexican Grill",
      "poi_type": "Restaurants",
      "poi_address": "413 N Main St, Livingston, CA 95334, USA",
      "poi_short_description": "Traditional Mexican fare such as burritos and bean dip, plus a full bar, in a vibrant space.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630c-1325-7339-8149-55e0289c3340.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f630c-1325-7339-8149-55e0289c3340",
        "storage_key": "property/6767906449167478/019f630c-1325-7339-8149-55e0289c3340.webp",
        "width": 1125,
        "height": 573
      },
      "poi_business_url": "http://villasmexicangrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8280238129517535479&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "villas-mexican-grill",
      "poi_latitude": "37.3903713",
      "poi_longitude": "-120.7211681",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-7636-706b-a04a-89d939f18bbd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f630a-7636-706b-a04a-89d939f18bbd",
        "storage_key": "property/6767906449167478/019f630a-7636-706b-a04a-89d939f18bbd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJUcsBVHgNkYAR96CJTbVQ6XI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "false",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "poi_name": "La Morenita Mexican Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "242 N Main St, Livingston, CA 95334, USA",
      "poi_short_description": "Casual eatery serving Mexican classics such as burritos, enchiladas, and molcajete, plus beer and wine.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630c-15a5-730d-8b1d-0aedad343145.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f630c-15a5-730d-8b1d-0aedad343145",
        "storage_key": "property/6767906449167478/019f630c-15a5-730d-8b1d-0aedad343145.webp",
        "width": 622,
        "height": 1280
      },
      "poi_business_url": "https://lamorenitaca.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8242960729770313479&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-morenita-mexican-restaurant",
      "poi_latitude": "37.388869",
      "poi_longitude": "-120.7212407",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 209-394-3349",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-7636-706b-a04a-89d939f18bbd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f630a-7636-706b-a04a-89d939f18bbd",
        "storage_key": "property/6767906449167478/019f630a-7636-706b-a04a-89d939f18bbd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJybytvHkNkYARB0d0UxzhZHI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "false",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "poi_name": "Mayrita's Fine Mexican Seafood",
      "poi_type": "Restaurants",
      "poi_address": "341 N Main St, Livingston, CA 95334, USA",
      "poi_short_description": "Clean Mexican spot for ceviche and tortas and tacos, plus kids' menu.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630c-14f7-7738-8667-8fbf8bdc2e05.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f630c-14f7-7738-8667-8fbf8bdc2e05",
        "storage_key": "property/6767906449167478/019f630c-14f7-7738-8667-8fbf8bdc2e05.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=8537311366569762639&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mayritas-fine-mexican-seafood",
      "poi_latitude": "37.3899947",
      "poi_longitude": "-120.721655",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 209-394-8580",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-7636-706b-a04a-89d939f18bbd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f630a-7636-706b-a04a-89d939f18bbd",
        "storage_key": "property/6767906449167478/019f630a-7636-706b-a04a-89d939f18bbd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0VFFrnkNkYART59LjXSfenY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "false",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "poi_name": "Geneo's Pizza",
      "poi_type": "Restaurants",
      "poi_address": "307 N Main St, Livingston, CA 95334, USA",
      "poi_short_description": "Casual pizzeria with a play area for kids serving burgers, as well as chicken and pizza pies.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-41d2-779a-bc71-162f66c64c16.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f630a-41d2-779a-bc71-162f66c64c16",
        "storage_key": "property/6767906449167478/019f630a-41d2-779a-bc71-162f66c64c16.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=12236585291027371868&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "geneos-pizza",
      "poi_latitude": "37.3895471",
      "poi_longitude": "-120.7217985",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 209-394-8444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-7636-706b-a04a-89d939f18bbd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f630a-7636-706b-a04a-89d939f18bbd",
        "storage_key": "property/6767906449167478/019f630a-7636-706b-a04a-89d939f18bbd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQyJws3kNkYARXNd0b30V0ak",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "false",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "poi_name": "Pizza Twist",
      "poi_type": "Restaurants",
      "poi_address": "1471 B St Ste b, Livingston, CA 95334, USA",
      "poi_short_description": "Variety of vegetarian, vegan and halal pizzas baked with local ingredients, plus wings and breads.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630c-145f-75aa-8104-235f54b2403e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f630c-145f-75aa-8104-235f54b2403e",
        "storage_key": "property/6767906449167478/019f630c-145f-75aa-8104-235f54b2403e.webp",
        "width": 680,
        "height": 510
      },
      "poi_business_url": "https://www.pizzatwist.com/locations/best-pizza-in-livingston-ca",
      "poi_directions_map_url": "https://maps.google.com/?cid=5963786297461806735&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pizza-twist",
      "poi_latitude": "37.3867927",
      "poi_longitude": "-120.7230081",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 209-398-2221",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-7636-706b-a04a-89d939f18bbd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f630a-7636-706b-a04a-89d939f18bbd",
        "storage_key": "property/6767906449167478/019f630a-7636-706b-a04a-89d939f18bbd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJySItR3oNkYARj5aNQAqgw1I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "false",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "poi_name": "Mundo's Latin Grill & Cantina",
      "poi_type": "Restaurants",
      "poi_address": "687 N Golden State Blvd, Turlock, CA 95380, USA",
      "poi_short_description": "Relaxed eatery-bar serving a mixed menu of classic & creative Mexican & South American fare.",
      "poi_long_description": "Relaxed eatery-bar serving a mixed menu of classic & creative Mexican & South American fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630c-135f-76be-b6d1-464a0bca2170.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f630c-135f-76be-b6d1-464a0bca2170",
        "storage_key": "property/6767906449167478/019f630c-135f-76be-b6d1-464a0bca2170.webp",
        "width": 640,
        "height": 637
      },
      "poi_business_url": "http://mundoslatingrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13088623826881112573&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mundos-latin-grill--cantina",
      "poi_latitude": "37.49900909999999",
      "poi_longitude": "-120.8509542",
      "poi_miles_from_property": "12.8 mi",
      "poi_walking_minutes": "4 hours 38 mins",
      "poi_biking_minutes": "1 hour 8 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 209-632-4004",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-7636-706b-a04a-89d939f18bbd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f630a-7636-706b-a04a-89d939f18bbd",
        "storage_key": "property/6767906449167478/019f630a-7636-706b-a04a-89d939f18bbd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJExPjtbIHkYAR_Wn2JwYipLU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "latin_american_restaurant"
    },
    {
      "id": "false",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "poi_name": "Frutal Ràspados",
      "poi_type": "Restaurants",
      "poi_address": "1439 Crowell St, Livingston, CA 95334, USA",
      "poi_short_description": "Casual Mexican eatery dishing up comfort food and quick bites for lunch, plus smoothies.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630c-147f-7709-88e4-6ed7e51e65f4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f630c-147f-7709-88e4-6ed7e51e65f4",
        "storage_key": "property/6767906449167478/019f630c-147f-7709-88e4-6ed7e51e65f4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=12712230663051965107&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "frutal-rspados",
      "poi_latitude": "37.3892136",
      "poi_longitude": "-120.7205048",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 209-394-7759",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-7636-706b-a04a-89d939f18bbd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f630a-7636-706b-a04a-89d939f18bbd",
        "storage_key": "property/6767906449167478/019f630a-7636-706b-a04a-89d939f18bbd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0dZGoHkNkYARs3IKjm_qarA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "false",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "poi_name": "Five Rivers Bar & Grill",
      "poi_type": "Restaurants",
      "poi_address": "2295 F St, Livingston, CA 95334, USA",
      "poi_short_description": "Casual eatery featuring classic Indian fare but also serving pizza, plus a full bar.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630c-1439-71f1-9069-f69724c19b55.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f630c-1439-71f1-9069-f69724c19b55",
        "storage_key": "property/6767906449167478/019f630c-1439-71f1-9069-f69724c19b55.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://fiveriversbargrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5392865881797374606&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "five-rivers-bar--grill",
      "poi_latitude": "37.3824682",
      "poi_longitude": "-120.7125921",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 209-394-6700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-7636-706b-a04a-89d939f18bbd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f630a-7636-706b-a04a-89d939f18bbd",
        "storage_key": "property/6767906449167478/019f630a-7636-706b-a04a-89d939f18bbd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJR_yGfGINkYARjjLbZfJO10o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "indian_restaurant"
    },
    {
      "id": "false",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "poi_name": "La Tiendita",
      "poi_type": "Shopping & Retail",
      "poi_address": "1925 F St, Livingston, CA 95334, USA",
      "poi_short_description": "Small Mexican grocery store carrying authentic products from the state of Michoacan, such as tortas.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630c-1550-71a8-9e91-8f447edf9f43.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f630c-1550-71a8-9e91-8f447edf9f43",
        "storage_key": "property/6767906449167478/019f630c-1550-71a8-9e91-8f447edf9f43.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=3581847972143182693&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-tiendita",
      "poi_latitude": "37.3822936",
      "poi_longitude": "-120.7171605",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 209-394-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-7636-706b-a04a-861f6afb0adf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f630a-7636-706b-a04a-861f6afb0adf",
        "storage_key": "property/6767906449167478/019f630a-7636-706b-a04a-861f6afb0adf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJrSxfZGMNkYARZTMM08BHtTE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "false",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "poi_name": "Chand sweets & Catering Foods",
      "poi_type": "Restaurants",
      "poi_address": "430 Main St, Livingston, CA 95334, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630c-1805-77ed-a81d-6df5aa15ed99.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f630c-1805-77ed-a81d-6df5aa15ed99",
        "storage_key": "property/6767906449167478/019f630c-1805-77ed-a81d-6df5aa15ed99.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=13043458327416016812&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chand-sweets--catering-foods",
      "poi_latitude": "37.3864321",
      "poi_longitude": "-120.7235217",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 209-446-1206",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-7636-706b-a04a-89d939f18bbd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f630a-7636-706b-a04a-89d939f18bbd",
        "storage_key": "property/6767906449167478/019f630a-7636-706b-a04a-89d939f18bbd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJoctLVRoNkYARrA8-2D2sA7U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "indian_restaurant"
    },
    {
      "id": "false",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "poi_name": "Sueño Coffee Co.",
      "poi_type": "Restaurants",
      "poi_address": "1744 D St, Livingston, CA 95334, USA",
      "poi_short_description": "Coffeehouse serving espresso drinks, bagel sandwiches, pastries and other eats.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630c-1749-768c-88ca-2c7e7b13409c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f630c-1749-768c-88ca-2c7e7b13409c",
        "storage_key": "property/6767906449167478/019f630c-1749-768c-88ca-2c7e7b13409c.webp",
        "width": 1006,
        "height": 1280
      },
      "poi_business_url": "http://suenocoffeeco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6296567354194329525&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sueo-coffee-co",
      "poi_latitude": "37.3839966",
      "poi_longitude": "-120.7190757",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630c-40ec-751d-95ee-1b91931a1241.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f630c-40ec-751d-95ee-1b91931a1241",
        "storage_key": "property/6767906449167478/019f630c-40ec-751d-95ee-1b91931a1241.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJnfOv510NkYARtf8S46XmYVc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "false",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "poi_name": "Panda Express",
      "poi_type": "Restaurants",
      "poi_address": "412 Winton Pkwy, Livingston, CA 95334, USA",
      "poi_short_description": "Fast-food chain for Chinese standards, including some health-conscious options.",
      "poi_long_description": "Fast-food chain for Chinese standards, including some health-conscious options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630c-1a8a-74e9-ad70-cef0d8a96fba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f630c-1a8a-74e9-ad70-cef0d8a96fba",
        "storage_key": "property/6767906449167478/019f630c-1a8a-74e9-ad70-cef0d8a96fba.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.pandaexpress.com/locations/ca/livingston/2801?utm_source=google_gbp&utm_medium=organic&utm_campaign=websitelink",
      "poi_directions_map_url": "https://maps.google.com/?cid=8388591645648689381&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "panda-express",
      "poi_latitude": "37.3873519",
      "poi_longitude": "-120.7368136",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 209-394-0898",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-7636-706b-a04a-89d939f18bbd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f630a-7636-706b-a04a-89d939f18bbd",
        "storage_key": "property/6767906449167478/019f630a-7636-706b-a04a-89d939f18bbd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZfRGmgoNkYAR5RizNKhDanQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "false",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "poi_name": "Kwik Serv Grocery",
      "poi_type": "Shopping & Retail",
      "poi_address": "1405 Davis St, Livingston, CA 95334, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630c-1bd3-7157-8639-3d543d1d74ff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f630c-1bd3-7157-8639-3d543d1d74ff",
        "storage_key": "property/6767906449167478/019f630c-1bd3-7157-8639-3d543d1d74ff.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=16672775737870528769&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kwik-serv-grocery",
      "poi_latitude": "37.3902752",
      "poi_longitude": "-120.7204476",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 209-394-7273",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-7636-706b-a04a-861f6afb0adf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f630a-7636-706b-a04a-861f6afb0adf",
        "storage_key": "property/6767906449167478/019f630a-7636-706b-a04a-861f6afb0adf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMSImAHkNkYARATGGizKZYec",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "false",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "poi_name": "Amigo's Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "Livingston, CA 95334, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=5059813173237905467&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amigos-market",
      "poi_latitude": "37.3891364",
      "poi_longitude": "-120.720399",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-761f-73e5-9e3b-ef90cb7f5772.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f630a-761f-73e5-9e3b-ef90cb7f5772",
        "storage_key": "property/6767906449167478/019f630a-761f-73e5-9e3b-ef90cb7f5772.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5XsPC3kNkYARO_iv5EUROEY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "point_of_interest"
    },
    {
      "id": "false",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "poi_name": "Liberty Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "1471 B St E, Livingston, CA 95334, USA",
      "poi_short_description": "Mom-&-pop grocery store featuring weekly coupon deals, plus meat and produce departments.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630c-1d7d-71a2-9df2-6269099c83d0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f630c-1d7d-71a2-9df2-6269099c83d0",
        "storage_key": "property/6767906449167478/019f630c-1d7d-71a2-9df2-6269099c83d0.webp",
        "width": 622,
        "height": 1280
      },
      "poi_business_url": "https://libertymkt.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17213750798411675520&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "liberty-market",
      "poi_latitude": "37.3864652",
      "poi_longitude": "-120.722152",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 209-394-4920",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-7636-706b-a04a-861f6afb0adf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f630a-7636-706b-a04a-861f6afb0adf",
        "storage_key": "property/6767906449167478/019f630a-7636-706b-a04a-861f6afb0adf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHSsGPnoNkYARgLdsFyaH4-4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "false",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "poi_name": "DG Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "323 N Main St, Livingston, CA 95334, USA",
      "poi_short_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_long_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-41c5-76bb-a943-8e752f433af8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f630a-41c5-76bb-a943-8e752f433af8",
        "storage_key": "property/6767906449167478/019f630a-41c5-76bb-a943-8e752f433af8.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.dollargeneral.com/store-directory/ca/livingston/14684",
      "poi_directions_map_url": "https://maps.google.com/?cid=10389746991992925372&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dg-market",
      "poi_latitude": "37.3897995",
      "poi_longitude": "-120.7216503",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 209-850-2096",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-7636-706b-a04a-861f6afb0adf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f630a-7636-706b-a04a-861f6afb0adf",
        "storage_key": "property/6767906449167478/019f630a-7636-706b-a04a-861f6afb0adf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxWDmr3kNkYARvOzri9fLL5A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "false",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "poi_name": "Rancho San Miguel Markets",
      "poi_type": "Shopping & Retail",
      "poi_address": "444 Winton Pkwy, Livingston, CA 95334, USA",
      "poi_short_description": "Mexican-focused grocer featuring a store-made bakery section, prepared foods and deli items.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-40dd-75ba-8c6a-caf0af9583f6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f630a-40dd-75ba-8c6a-caf0af9583f6",
        "storage_key": "property/6767906449167478/019f630a-40dd-75ba-8c6a-caf0af9583f6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://ranchosanmiguelmarkets.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1261958149103997606&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rancho-san-miguel-markets",
      "poi_latitude": "37.387015",
      "poi_longitude": "-120.735044",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 209-394-6768",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-7636-706b-a04a-861f6afb0adf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f630a-7636-706b-a04a-861f6afb0adf",
        "storage_key": "property/6767906449167478/019f630a-7636-706b-a04a-861f6afb0adf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpdY0ywoNkYARptLAHkBggxE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "false",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "474 Winton Pkwy, Livingston, CA 95334, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630c-1bc8-725f-879d-577ee0ce1588.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f630c-1bc8-725f-879d-577ee0ce1588",
        "storage_key": "property/6767906449167478/019f630c-1bc8-725f-879d-577ee0ce1588.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/livingston-ca-pharmacies/474-winton-pkwy-livingston-ca-95334/storeid=10360?WT.mc_id=LS_GOOGLE_RX_10360",
      "poi_directions_map_url": "https://maps.google.com/?cid=17221179281636265540&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "37.3863192",
      "poi_longitude": "-120.7366887",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 209-394-6785",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630c-4120-7518-8bba-2d8e28b2bc44.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f630c-4120-7518-8bba-2d8e28b2bc44",
        "storage_key": "property/6767906449167478/019f630c-4120-7518-8bba-2d8e28b2bc44.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq0cL6QoNkYARRA4_n1Dr_e4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "false",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "poi_name": "Fiesta Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "344 Main St, Livingston, CA 95334, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630c-1d33-716b-82bb-46031bff1d31.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f630c-1d33-716b-82bb-46031bff1d31",
        "storage_key": "property/6767906449167478/019f630c-1d33-716b-82bb-46031bff1d31.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=15614387593220287329&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fiesta-market",
      "poi_latitude": "37.3867943",
      "poi_longitude": "-120.7234661",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 209-394-8273",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-7636-706b-a04a-861f6afb0adf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f630a-7636-706b-a04a-861f6afb0adf",
        "storage_key": "property/6767906449167478/019f630a-7636-706b-a04a-861f6afb0adf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPXS5qnANkYARYWspl8lysdg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "false",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "poi_name": "Brother's Food Mart",
      "poi_type": "Shopping & Retail",
      "poi_address": "690 Hammatt Ave, Livingston, CA 95334, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630c-1dbf-7275-bd60-88defee3e7f8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f630c-1dbf-7275-bd60-88defee3e7f8",
        "storage_key": "property/6767906449167478/019f630c-1dbf-7275-bd60-88defee3e7f8.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=17053852638302696036&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brothers-food-mart",
      "poi_latitude": "37.389126",
      "poi_longitude": "-120.711679",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 209-394-1223",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630c-40ee-7514-a58e-11c7d7672cca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f630c-40ee-7514-a58e-11c7d7672cca",
        "storage_key": "property/6767906449167478/019f630c-40ee-7514-a58e-11c7d7672cca.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJkbpnC4ISkYARZPLjjZ50q-w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "false",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "poi_name": "Livingston Middle School",
      "poi_type": "Education",
      "poi_address": "101 F St, Livingston, CA 95334, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630c-1d64-73cf-bbce-dbbc53b638f3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f630c-1d64-73cf-bbce-dbbc53b638f3",
        "storage_key": "property/6767906449167478/019f630c-1d64-73cf-bbce-dbbc53b638f3.webp",
        "width": 974,
        "height": 1280
      },
      "poi_business_url": "https://lms.livingstonusd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17148514513511057104&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "livingston-middle-school",
      "poi_latitude": "37.3830466",
      "poi_longitude": "-120.740596",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 209-394-5450",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630c-40f0-72e7-93d2-aa5bb31a874f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f630c-40f0-72e7-93d2-aa5bb31a874f",
        "storage_key": "property/6767906449167478/019f630c-40f0-72e7-93d2-aa5bb31a874f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJf7vhTwkNkYAR0AZ14xfD--0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "false",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "poi_name": "Deborah Clipper Child Dev Center",
      "poi_type": "Education",
      "poi_address": "1001 F St, Livingston, CA 95334, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.cccds.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15458443887838434552&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "deborah-clipper-child-dev-center",
      "poi_latitude": "37.3824665",
      "poi_longitude": "-120.728498",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 209-394-0066",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630c-40f0-72e7-93d2-aa5bb31a874f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f630c-40f0-72e7-93d2-aa5bb31a874f",
        "storage_key": "property/6767906449167478/019f630c-40f0-72e7-93d2-aa5bb31a874f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJOTdjmnENkYAR-BTrStBsh9Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "false",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "poi_name": "Livingston Child Dev Center",
      "poi_type": "Education",
      "poi_address": "848 Prusso St, Livingston, CA 95334, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.livingstonusd.org/apps/pages/index.jsp?uREC_ID=343397&type=d",
      "poi_directions_map_url": "https://maps.google.com/?cid=18202842901004918391&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "livingston-child-dev-center",
      "poi_latitude": "37.3826636",
      "poi_longitude": "-120.7273303",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 209-394-5485",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630c-40f0-72e7-93d2-aa5bb31a874f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f630c-40f0-72e7-93d2-aa5bb31a874f",
        "storage_key": "property/6767906449167478/019f630c-40f0-72e7-93d2-aa5bb31a874f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJP-V_sXENkYARd56j-Cx9nfw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "false",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "poi_name": "Selma Herndon Elementary School",
      "poi_type": "Education",
      "poi_address": "714 Prusso St, Livingston, CA 95334, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://sh.livingstonusd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3321608907207891746&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "selma-herndon-elementary-school",
      "poi_latitude": "37.3839535",
      "poi_longitude": "-120.7278646",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 209-394-5480",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630c-40f0-72e7-93d2-aa5bb31a874f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f630c-40f0-72e7-93d2-aa5bb31a874f",
        "storage_key": "property/6767906449167478/019f630c-40f0-72e7-93d2-aa5bb31a874f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJS9o6bXENkYARIlvm1LO5GC4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "false",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "poi_name": "Yamato Colony Elementary School",
      "poi_type": "Education",
      "poi_address": "800 N Main St, Livingston, CA 95334, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630c-2180-73cb-b8cd-89f2ccbedebb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f630c-2180-73cb-b8cd-89f2ccbedebb",
        "storage_key": "property/6767906449167478/019f630c-2180-73cb-b8cd-89f2ccbedebb.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://yc.livingstonusd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7797855222847080119&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "yamato-colony-elementary-school",
      "poi_latitude": "37.3927803",
      "poi_longitude": "-120.7184906",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 209-394-5470",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630c-40f0-72e7-93d2-aa5bb31a874f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f630c-40f0-72e7-93d2-aa5bb31a874f",
        "storage_key": "property/6767906449167478/019f630c-40f0-72e7-93d2-aa5bb31a874f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJefTskXgNkYARt4a5pwKMN2w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "false",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "poi_name": "Livingston High School",
      "poi_type": "Education",
      "poi_address": "1617 Main St, Livingston, CA 95334, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630c-2088-7105-b19a-9b1ef7df1fd8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f630c-2088-7105-b19a-9b1ef7df1fd8",
        "storage_key": "property/6767906449167478/019f630c-2088-7105-b19a-9b1ef7df1fd8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://lhs.muhsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1142446564961932881&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "livingston-high-school",
      "poi_latitude": "37.3755111",
      "poi_longitude": "-120.7224121",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 209-325-2600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630c-40f0-72e7-93d2-aa5bb31a874f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f630c-40f0-72e7-93d2-aa5bb31a874f",
        "storage_key": "property/6767906449167478/019f630c-40f0-72e7-93d2-aa5bb31a874f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ4SFzKGYNkYARUdZrDxnJ2g8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "false",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "poi_name": "Campus Park Elementary School",
      "poi_type": "Education",
      "poi_address": "1845 H St, Livingston, CA 95334, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630c-201e-7790-81d7-6a5a2a4375bc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f630c-201e-7790-81d7-6a5a2a4375bc",
        "storage_key": "property/6767906449167478/019f630c-201e-7790-81d7-6a5a2a4375bc.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.livingstonusd.org/apps/pages/index.jsp?type=d&uREC_ID=343463&pREC_ID=813201",
      "poi_directions_map_url": "https://maps.google.com/?cid=17068247454650648067&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "campus-park-elementary-school",
      "poi_latitude": "37.3806469",
      "poi_longitude": "-120.7178875",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 209-394-5460",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630c-40f0-72e7-93d2-aa5bb31a874f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f630c-40f0-72e7-93d2-aa5bb31a874f",
        "storage_key": "property/6767906449167478/019f630c-40f0-72e7-93d2-aa5bb31a874f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ5RcuDGQNkYARA8bq6KCY3uw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "false",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "poi_name": "Walnut Child Development Center",
      "poi_type": "Education",
      "poi_address": "2600 Walnut Ave, Livingston, CA 95334, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.livingstonusd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14576192225779827617&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walnut-child-development-center",
      "poi_latitude": "37.3890976",
      "poi_longitude": "-120.706196",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 209-394-5440",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630c-40f0-72e7-93d2-aa5bb31a874f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f630c-40f0-72e7-93d2-aa5bb31a874f",
        "storage_key": "property/6767906449167478/019f630c-40f0-72e7-93d2-aa5bb31a874f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJbTI4u4MSkYARocNq85kJSco",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "false",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "poi_name": "Merced College",
      "poi_type": "Education",
      "poi_address": "3600 M St, Merced, CA 95348, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630c-20cd-7380-a124-f80d1c63741d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f630c-20cd-7380-a124-f80d1c63741d",
        "storage_key": "property/6767906449167478/019f630c-20cd-7380-a124-f80d1c63741d.webp",
        "width": 697,
        "height": 392
      },
      "poi_business_url": "https://www.mccd.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9473436170862547826&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "merced-college",
      "poi_latitude": "37.3336715",
      "poi_longitude": "-120.4729896",
      "poi_miles_from_property": "16.3 mi",
      "poi_walking_minutes": "5 hours 54 mins",
      "poi_biking_minutes": "1 hour 26 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 209-384-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630c-40f0-72e7-93d2-aa5bb31a874f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f630c-40f0-72e7-93d2-aa5bb31a874f",
        "storage_key": "property/6767906449167478/019f630c-40f0-72e7-93d2-aa5bb31a874f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJi0VhMc5DkYARclOZRgFoeIM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "false",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "poi_name": "University of California Merced",
      "poi_type": "Education",
      "poi_address": "5200 Lake Rd, Merced, CA 95343, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630c-2139-74bf-a15c-1290afd20675.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f630c-2139-74bf-a15c-1290afd20675",
        "storage_key": "property/6767906449167478/019f630c-2139-74bf-a15c-1290afd20675.webp",
        "width": 870,
        "height": 450
      },
      "poi_business_url": "https://www.ucmerced.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14738688066508597268&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-california-merced",
      "poi_latitude": "37.3647478",
      "poi_longitude": "-120.4242449",
      "poi_miles_from_property": "19.1 mi",
      "poi_walking_minutes": "6 hours 57 mins",
      "poi_biking_minutes": "1 hour 50 mins",
      "poi_driving_minutes": "30 mins",
      "poi_business_phone": "+1 209-228-4400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630c-40f0-72e7-93d2-aa5bb31a874f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f630c-40f0-72e7-93d2-aa5bb31a874f",
        "storage_key": "property/6767906449167478/019f630c-40f0-72e7-93d2-aa5bb31a874f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ1bmXDKxGkYARFKiII7VWisw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "false",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "poi_name": "Livingston Historic Museum",
      "poi_type": "Entertainment",
      "poi_address": "1306 C St, Livingston, CA 95334, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-411b-71c1-ac16-741a80283ff4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f630a-411b-71c1-ac16-741a80283ff4",
        "storage_key": "property/6767906449167478/019f630a-411b-71c1-ac16-741a80283ff4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cityoflivingston.org/recreation/page/livingston-historical-museum",
      "poi_directions_map_url": "https://maps.google.com/?cid=2710310382931782198&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "livingston-historic-museum",
      "poi_latitude": "37.3849805",
      "poi_longitude": "-120.7241638",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 209-394-2376",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-763b-7106-bf8c-14f68cdefb1d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f630a-763b-7106-bf8c-14f68cdefb1d",
        "storage_key": "property/6767906449167478/019f630a-763b-7106-bf8c-14f68cdefb1d.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJBV3rgnANkYARNqqz9e70nCU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "false",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "poi_name": "Livingston Memorial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Main St, Livingston, CA 95334, USA",
      "poi_short_description": "Public park offering a children's playground and picnic tables, plus shade from trees.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-5460-727e-beec-3f290ca22dec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f630a-5460-727e-beec-3f290ca22dec",
        "storage_key": "property/6767906449167478/019f630a-5460-727e-beec-3f290ca22dec.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.livingstoncity.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16086768151020336851&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "livingston-memorial-park",
      "poi_latitude": "37.378172",
      "poi_longitude": "-120.722934",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 209-394-8041",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-7622-7218-9912-dbe4dac573fc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f630a-7622-7218-9912-dbe4dac573fc",
        "storage_key": "property/6767906449167478/019f630a-7622-7218-9912-dbe4dac573fc.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJmTiv8WUNkYAR03ai6WauP98",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "false",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "poi_name": "Riverdance Farms Gate",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "12230 Livingston Cressey Road Livingston, CA 95334, (Farm Gate ~ 1/2 mile NE across from 11801), Livingston, CA 95334, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630c-2624-775a-8e60-748a642f53ef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f630c-2624-775a-8e60-748a642f53ef",
        "storage_key": "property/6767906449167478/019f630c-2624-775a-8e60-748a642f53ef.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.riverdancefarms.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8760040905755138093&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "riverdance-farms-gate",
      "poi_latitude": "37.416749",
      "poi_longitude": "-120.702253",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 209-761-0081",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-761f-73e5-9e3b-ef90cb7f5772.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f630a-761f-73e5-9e3b-ef90cb7f5772",
        "storage_key": "property/6767906449167478/019f630a-761f-73e5-9e3b-ef90cb7f5772.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJczAbQXQSkYARLRhthcrqkXk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "farm"
    },
    {
      "id": "false",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "poi_name": "McConnell State Recreation",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8800 McConnell Rd, Ballico, CA 95303, USA",
      "poi_short_description": "Riverside state park featuring fishing, a campground and clean bathrooms.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-5451-765f-a22d-81c84f0eb8e9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f630a-5451-765f-a22d-81c84f0eb8e9",
        "storage_key": "property/6767906449167478/019f630a-5451-765f-a22d-81c84f0eb8e9.webp",
        "width": 1280,
        "height": 957
      },
      "poi_business_url": "http://www.parks.ca.gov/?page_id=554",
      "poi_directions_map_url": "https://maps.google.com/?cid=14172358452304016956&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mcconnell-state-recreation",
      "poi_latitude": "37.4158738",
      "poi_longitude": "-120.7110885",
      "poi_miles_from_property": "7.9 mi",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 209-394-7755",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-7622-7218-9912-dbe4dac573fc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f630a-7622-7218-9912-dbe4dac573fc",
        "storage_key": "property/6767906449167478/019f630a-7622-7218-9912-dbe4dac573fc.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJM2k5MnUSkYARPPYVi-xUrsQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "false",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "poi_name": "Merced's Applegate Park Zoo",
      "poi_type": "Entertainment",
      "poi_address": "1045 W 25th St, Merced, CA 95340, USA",
      "poi_short_description": "This park with picnic areas & a playground is home to a small zoo that shelters native wildlife.",
      "poi_long_description": "This park with picnic areas & a playground is home to a small zoo that shelters native wildlife.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630c-25bc-7323-b66c-076a586af747.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f630c-25bc-7323-b66c-076a586af747",
        "storage_key": "property/6767906449167478/019f630c-25bc-7323-b66c-076a586af747.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.cityofmerced.gov/parks-and-community/applegate-park-zoo",
      "poi_directions_map_url": "https://maps.google.com/?cid=5954065352687428456&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "merceds-applegate-park-zoo",
      "poi_latitude": "37.312783",
      "poi_longitude": "-120.4872351",
      "poi_miles_from_property": "15.4 mi",
      "poi_walking_minutes": "5 hours 36 mins",
      "poi_biking_minutes": "1 hour 17 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 209-385-6855",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-761f-73e5-9e3b-ef90cb7f5772.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f630a-761f-73e5-9e3b-ef90cb7f5772",
        "storage_key": "property/6767906449167478/019f630a-761f-73e5-9e3b-ef90cb7f5772.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxUyhIlJCkYARaCNlbOQWoVI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "false",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "poi_name": "Merced Theatre",
      "poi_type": "Entertainment",
      "poi_address": "301 W Main St, Merced, CA 95340, USA",
      "poi_short_description": "This 1,640-seat music venue with a balcony hosts national names & tribute bands, plus kids' shows.",
      "poi_long_description": "This 1,640-seat music venue with a balcony hosts national names & tribute bands, plus kids' shows.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630c-2483-757b-9f8c-14158c8427ef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f630c-2483-757b-9f8c-14158c8427ef",
        "storage_key": "property/6767906449167478/019f630c-2483-757b-9f8c-14158c8427ef.webp",
        "width": 618,
        "height": 348
      },
      "poi_business_url": "https://www.mercedtheatre.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10007604698239942355&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "merced-theatre",
      "poi_latitude": "37.3005163",
      "poi_longitude": "-120.4804655",
      "poi_miles_from_property": "16.0 mi",
      "poi_walking_minutes": "5 hours 50 mins",
      "poi_biking_minutes": "1 hour 25 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 209-381-0500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-761f-73e5-9e3b-ef90cb7f5772.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f630a-761f-73e5-9e3b-ef90cb7f5772",
        "storage_key": "property/6767906449167478/019f630a-761f-73e5-9e3b-ef90cb7f5772.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_15DPQJDkYAR0z4fU3Mn4oo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "false",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "poi_name": "The Mainzer",
      "poi_type": "Restaurants",
      "poi_address": "655 W Main St, Merced, CA 95340, USA",
      "poi_short_description": "Kid-friendly, casual eatery serving burgers, pizza and pancakes alongside fried chicken, beers, cocktails and wine.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630c-29ff-7108-a987-4d4ee86e3d22.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f630c-29ff-7108-a987-4d4ee86e3d22",
        "storage_key": "property/6767906449167478/019f630c-29ff-7108-a987-4d4ee86e3d22.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://themainzer.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3015332470054177617&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-mainzer",
      "poi_latitude": "37.302715",
      "poi_longitude": "-120.4859619",
      "poi_miles_from_property": "15.7 mi",
      "poi_walking_minutes": "5 hours 42 mins",
      "poi_biking_minutes": "1 hour 23 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 209-446-4001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-7636-706b-a04a-89d939f18bbd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f630a-7636-706b-a04a-89d939f18bbd",
        "storage_key": "property/6767906449167478/019f630a-7636-706b-a04a-89d939f18bbd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJe3DMF_9CkYARUctH1eec2Ck",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "false",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "poi_name": "Playhouse Merced",
      "poi_type": "Entertainment",
      "poi_address": "452 W Main St, Merced, CA 95340, USA",
      "poi_short_description": "Community-dedicated theater producing more than 10 plays per year & offering youth programs.",
      "poi_long_description": "Community-dedicated theater producing more than 10 plays per year & offering youth programs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630c-26ce-72d2-acde-3e8592cb6914.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f630c-26ce-72d2-acde-3e8592cb6914",
        "storage_key": "property/6767906449167478/019f630c-26ce-72d2-acde-3e8592cb6914.webp",
        "width": 960,
        "height": 639
      },
      "poi_business_url": "http://www.playhousemerced.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16140935909871760537&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "playhouse-merced",
      "poi_latitude": "37.3010722",
      "poi_longitude": "-120.4831667",
      "poi_miles_from_property": "15.8 mi",
      "poi_walking_minutes": "5 hours 46 mins",
      "poi_biking_minutes": "1 hour 24 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 209-725-8587",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-761f-73e5-9e3b-ef90cb7f5772.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f630a-761f-73e5-9e3b-ef90cb7f5772",
        "storage_key": "property/6767906449167478/019f630a-761f-73e5-9e3b-ef90cb7f5772.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ1oPE_5CkYARmbRAErEfAOA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "false",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "poi_name": "Merced Multicultural Arts Center",
      "poi_type": "Entertainment",
      "poi_address": "645 W Main St, Merced, CA 95340, USA",
      "poi_short_description": "Galleries showcasing temporary exhibitions by local & national artists.",
      "poi_long_description": "Galleries showcasing temporary exhibitions by local & national artists.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630c-2607-77a0-bedb-0c713a94549b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f630c-2607-77a0-bedb-0c713a94549b",
        "storage_key": "property/6767906449167478/019f630c-2607-77a0-bedb-0c713a94549b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.artsmerced.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4745063487150091635&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "merced-multicultural-arts-center",
      "poi_latitude": "37.3025763",
      "poi_longitude": "-120.4857462",
      "poi_miles_from_property": "15.7 mi",
      "poi_walking_minutes": "5 hours 42 mins",
      "poi_biking_minutes": "1 hour 24 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 209-388-1090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-761f-73e5-9e3b-ef90cb7f5772.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f630a-761f-73e5-9e3b-ef90cb7f5772",
        "storage_key": "property/6767906449167478/019f630a-761f-73e5-9e3b-ef90cb7f5772.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIYMXGv9CkYARc-1B5Bna2UE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_gallery"
    },
    {
      "id": "false",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "poi_name": "Merced County Courthouse Museum",
      "poi_type": "Entertainment",
      "poi_address": "W 21st &, N St, Merced, CA 95340, USA",
      "poi_short_description": "Local history museum in a restored 1875 building housing rotating exhibits, artifacts & a gift shop.",
      "poi_long_description": "Local history museum in a restored 1875 building housing rotating exhibits, artifacts & a gift shop.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630c-2881-73a8-9646-458ebfadcabf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f630c-2881-73a8-9646-458ebfadcabf",
        "storage_key": "property/6767906449167478/019f630c-2881-73a8-9646-458ebfadcabf.webp",
        "width": 1025,
        "height": 1280
      },
      "poi_business_url": "http://www.mercedmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14358373132377156680&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "merced-county-courthouse-museum",
      "poi_latitude": "37.3065201",
      "poi_longitude": "-120.4840484",
      "poi_miles_from_property": "16.0 mi",
      "poi_walking_minutes": "5 hours 48 mins",
      "poi_biking_minutes": "1 hour 21 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 209-723-2401",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-763b-7106-bf8c-14f68cdefb1d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f630a-763b-7106-bf8c-14f68cdefb1d",
        "storage_key": "property/6767906449167478/019f630a-763b-7106-bf8c-14f68cdefb1d.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJXUrbD1VCkYARSGzaO0owQ8c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "false",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "poi_name": "Livingston Community Health Center",
      "poi_type": "Health and Wellness",
      "poi_address": "600 B St, Livingston, CA 95334, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-5094-77a7-9707-b7e95c1dc31c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f630a-5094-77a7-9707-b7e95c1dc31c",
        "storage_key": "property/6767906449167478/019f630a-5094-77a7-9707-b7e95c1dc31c.webp",
        "width": 960,
        "height": 541
      },
      "poi_business_url": "http://lumirahealthcare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11217904521558223552&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "livingston-community-health-center",
      "poi_latitude": "37.385464",
      "poi_longitude": "-120.7339439",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 209-850-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-761e-746d-8e02-e70e2b890293.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f630a-761e-746d-8e02-e70e2b890293",
        "storage_key": "property/6767906449167478/019f630a-761e-746d-8e02-e70e2b890293.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJF-k1gW8NkYARwOq5M7oArps",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "false",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "poi_name": "LCH Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "600 B St Bldg B, Room 100, Livingston, CA 95334, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://visitlchpharmacy.org/app/#/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10664984637429035192&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lch-pharmacy",
      "poi_latitude": "37.3853962",
      "poi_longitude": "-120.7340149",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 209-850-3620",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630c-4120-7518-8bba-2d8e28b2bc44.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f630c-4120-7518-8bba-2d8e28b2bc44",
        "storage_key": "property/6767906449167478/019f630c-4120-7518-8bba-2d8e28b2bc44.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJy3eFqVMNkYARuLD0sAWjAZQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "false",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "poi_name": "Community Health Centers of America Livingston",
      "poi_type": "Health and Wellness",
      "poi_address": "517 Main St, Livingston, CA 95334, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.chcahealth.org/locations/livingston/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8794925076575200255&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "community-health-centers-of-america-livingston",
      "poi_latitude": "37.3856668",
      "poi_longitude": "-120.723154",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 209-445-2388",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-761f-73e5-9e3b-ef90cb7f5772.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f630a-761f-73e5-9e3b-ef90cb7f5772",
        "storage_key": "property/6767906449167478/019f630a-761f-73e5-9e3b-ef90cb7f5772.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJsacG93gNkYAR_6Nwd8LZDXo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "false",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "poi_name": "Rite Aid Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "500 Main St, Livingston, CA 95334, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630c-26ee-7123-8abd-d7455d81dad9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f630c-26ee-7123-8abd-d7455d81dad9",
        "storage_key": "property/6767906449167478/019f630c-26ee-7123-8abd-d7455d81dad9.webp",
        "width": 251,
        "height": 250
      },
      "poi_business_url": "https://www.riteaid.com/locations/ca/livingston/500-main-street.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=13919949215187948974&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rite-aid-pharmacy",
      "poi_latitude": "37.385531",
      "poi_longitude": "-120.7239505",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 209-394-8416",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630c-4120-7518-8bba-2d8e28b2bc44.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f630c-4120-7518-8bba-2d8e28b2bc44",
        "storage_key": "property/6767906449167478/019f630c-4120-7518-8bba-2d8e28b2bc44.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJiUTmSfANkYARrlXBZg-YLcE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "false",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "poi_name": "Dignity Health – Mercy Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "333 Mercy Ave, Merced, CA 95340, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630c-2878-709f-aaa3-a7f74a97b66f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f630c-2878-709f-aaa3-a7f74a97b66f",
        "storage_key": "property/6767906449167478/019f630c-2878-709f-aaa3-a7f74a97b66f.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.commonspirit.org/find-a-location/dignity-health-mercy-medical-center-1914",
      "poi_directions_map_url": "https://maps.google.com/?cid=8438806745003065955&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dignity-health--mercy-medical-center",
      "poi_latitude": "37.3399203",
      "poi_longitude": "-120.46718",
      "poi_miles_from_property": "17.0 mi",
      "poi_walking_minutes": "6 hours 11 mins",
      "poi_biking_minutes": "1 hour 30 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 209-564-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-761e-746d-8e02-e70e2b890293.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f630a-761e-746d-8e02-e70e2b890293",
        "storage_key": "property/6767906449167478/019f630a-761e-746d-8e02-e70e2b890293.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ58gRIttDkYARYwIUHAaqHHU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "false",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "poi_name": "Memorial Hospital Los Banos",
      "poi_type": "Health and Wellness",
      "poi_address": "520 W I St, Los Banos, CA 93635, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630c-28be-70d9-8327-e2cbfb0b3ba5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f630c-28be-70d9-8327-e2cbfb0b3ba5",
        "storage_key": "property/6767906449167478/019f630c-28be-70d9-8327-e2cbfb0b3ba5.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.sutterhealth.org/find-location/facility/memorial-hospital-los-banos-1043246682",
      "poi_directions_map_url": "https://maps.google.com/?cid=1006579276489581717&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "memorial-hospital-los-banos",
      "poi_latitude": "37.0640934",
      "poi_longitude": "-120.8591356",
      "poi_miles_from_property": "30.6 mi",
      "poi_walking_minutes": "11 hours 2 mins",
      "poi_biking_minutes": "2 hours 52 mins",
      "poi_driving_minutes": "42 mins",
      "poi_business_phone": "+1 209-826-0591",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-761e-746d-8e02-e70e2b890293.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f630a-761e-746d-8e02-e70e2b890293",
        "storage_key": "property/6767906449167478/019f630a-761e-746d-8e02-e70e2b890293.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJMd94-iJ_kYARlWRu1YQW-A0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "false",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "3155 R St, Merced, CA 95348, USA",
      "poi_short_description": "Chain fitness center offering tanning, spa services, and hydro massages, plus a friendly staff.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630c-2af3-7383-9fa3-f1d311b5cd3d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f630c-2af3-7383-9fa3-f1d311b5cd3d",
        "storage_key": "property/6767906449167478/019f630c-2af3-7383-9fa3-f1d311b5cd3d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/merced-ca?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=3276593829657468363&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "37.32149380000001",
      "poi_longitude": "-120.4881801",
      "poi_miles_from_property": "15.5 mi",
      "poi_walking_minutes": "5 hours 37 mins",
      "poi_biking_minutes": "1 hour 18 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 209-259-1572",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-761f-73e5-9e3b-ef90cb7f5772.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f630a-761f-73e5-9e3b-ef90cb7f5772",
        "storage_key": "property/6767906449167478/019f630a-761f-73e5-9e3b-ef90cb7f5772.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAyGv5kVDkYARy134WbrMeC0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "false",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "poi_name": "CrossFit Merced",
      "poi_type": "Health and Wellness",
      "poi_address": "900 Loughborough Dr, Merced, CA 95348, USA",
      "poi_short_description": "Air-conditioned gym offering group fitness routines as well as personal training, strength training and nutrition advice.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630c-2e36-733e-bd91-90c30c1162c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f630c-2e36-733e-bd91-90c30c1162c3",
        "storage_key": "property/6767906449167478/019f630c-2e36-733e-bd91-90c30c1162c3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://crossfitmerced.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15176204573076151725&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crossfit-merced",
      "poi_latitude": "37.3232583",
      "poi_longitude": "-120.4833695",
      "poi_miles_from_property": "15.7 mi",
      "poi_walking_minutes": "5 hours 42 mins",
      "poi_biking_minutes": "1 hour 19 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 209-440-0886",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-761f-73e5-9e3b-ef90cb7f5772.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f630a-761f-73e5-9e3b-ef90cb7f5772",
        "storage_key": "property/6767906449167478/019f630a-761f-73e5-9e3b-ef90cb7f5772.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJC53wZgNDkYARrd3c-Ka1nNI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "false",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "poi_name": "Valley Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1085 Bellevue Rd, City of Atwater, CA 95301, USA",
      "poi_short_description": "Members-only gym offering equipment, trainers, and a vibrant community.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630c-2d74-717c-8dfe-c0b1b2ccee33.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f630c-2d74-717c-8dfe-c0b1b2ccee33",
        "storage_key": "property/6767906449167478/019f630c-2d74-717c-8dfe-c0b1b2ccee33.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://valleyfitness.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5542862469073641664&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "valley-fitness",
      "poi_latitude": "37.3620605",
      "poi_longitude": "-120.603836",
      "poi_miles_from_property": "8.0 mi",
      "poi_walking_minutes": "2 hours 56 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 209-635-5440",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-761f-73e5-9e3b-ef90cb7f5772.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f630a-761f-73e5-9e3b-ef90cb7f5772",
        "storage_key": "property/6767906449167478/019f630a-761f-73e5-9e3b-ef90cb7f5772.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJG_lUum5rkYARwKD6Www07Ew",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "false",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "poi_name": "Joseph Gallo Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1201 Parkside Way, Livingston, CA 95334, USA",
      "poi_short_description": "Clean outdoor area with a playground that's popular with families.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-53cd-705f-968a-c607a6e7b785.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f630a-53cd-705f-968a-c607a6e7b785",
        "storage_key": "property/6767906449167478/019f630a-53cd-705f-968a-c607a6e7b785.webp",
        "width": 598,
        "height": 1280
      },
      "poi_business_url": "http://www.livingstoncity.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1481393549561425102&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "joseph-gallo-park",
      "poi_latitude": "37.3793721",
      "poi_longitude": "-120.7358323",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 209-394-8041",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-7622-7218-9912-dbe4dac573fc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f630a-7622-7218-9912-dbe4dac573fc",
        "storage_key": "property/6767906449167478/019f630a-7622-7218-9912-dbe4dac573fc.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJDeHGRQ0NkYARzuwpppX3jhQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "false",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "poi_name": "Arakelian Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Arakelian Park, Livingston, CA 95334, USA",
      "poi_short_description": "Open space featuring a playground and picnic tables, as well as disc golf.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-54b5-70fa-ada3-80e62c8e5e2a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f630a-54b5-70fa-ada3-80e62c8e5e2a",
        "storage_key": "property/6767906449167478/019f630a-54b5-70fa-ada3-80e62c8e5e2a.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://www.livingstoncity.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18030620753237336757&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arakelian-park",
      "poi_latitude": "37.3783928",
      "poi_longitude": "-120.7288969",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 209-394-8041",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-7622-7218-9912-dbe4dac573fc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f630a-7622-7218-9912-dbe4dac573fc",
        "storage_key": "property/6767906449167478/019f630a-7622-7218-9912-dbe4dac573fc.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJD3tMim4NkYARtWJ_dAuiOfo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "false",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "poi_name": "Lucero Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Celia Dr, Livingston, CA 95334, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630c-2efc-73cd-8c4c-95969a7fba37.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f630c-2efc-73cd-8c4c-95969a7fba37",
        "storage_key": "property/6767906449167478/019f630c-2efc-73cd-8c4c-95969a7fba37.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.livingstoncity.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2178615204654251130&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lucero-park",
      "poi_latitude": "37.3909252",
      "poi_longitude": "-120.7181396",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 209-394-8041",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-7622-7218-9912-dbe4dac573fc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f630a-7622-7218-9912-dbe4dac573fc",
        "storage_key": "property/6767906449167478/019f630a-7622-7218-9912-dbe4dac573fc.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJxUZm1ngNkYARenyuX_z-Ox4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "false",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "poi_name": "Frederick Worden Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "923 Park View Dr, Livingston, CA 95334, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630c-2ed7-770d-8d83-228403855884.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f630c-2ed7-770d-8d83-228403855884",
        "storage_key": "property/6767906449167478/019f630c-2ed7-770d-8d83-228403855884.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.livingstoncity.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12744765615829058817&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "frederick-worden-park",
      "poi_latitude": "37.3719156",
      "poi_longitude": "-120.7297458",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 209-394-8041",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-7622-7218-9912-dbe4dac573fc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f630a-7622-7218-9912-dbe4dac573fc",
        "storage_key": "property/6767906449167478/019f630a-7622-7218-9912-dbe4dac573fc.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJmTZQImoNkYARAYUajc2A3rA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "false",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "poi_name": "Don Meyer Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "964 Mori Ct, Livingston, CA 95334, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630c-3022-739a-9e99-c55f7d7c8950.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f630c-3022-739a-9e99-c55f7d7c8950",
        "storage_key": "property/6767906449167478/019f630c-3022-739a-9e99-c55f7d7c8950.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.livingstoncity.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10695423533639769779&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "don-meyer-park",
      "poi_latitude": "37.3938408",
      "poi_longitude": "-120.710341",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 209-394-8041",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-7622-7218-9912-dbe4dac573fc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f630a-7622-7218-9912-dbe4dac573fc",
        "storage_key": "property/6767906449167478/019f630a-7622-7218-9912-dbe4dac573fc.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ66BQRoASkYARs57zfAnHbZQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "false",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "poi_name": "Singh Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1500-1698 Amaretto Way, Livingston, CA 95334, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630c-2ebe-709d-b459-cec52825566a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f630c-2ebe-709d-b459-cec52825566a",
        "storage_key": "property/6767906449167478/019f630c-2ebe-709d-b459-cec52825566a.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://www.livingstoncity.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7042517878563716412&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "singh-park",
      "poi_latitude": "37.3755127",
      "poi_longitude": "-120.7073222",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 209-394-8041",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-7622-7218-9912-dbe4dac573fc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f630a-7622-7218-9912-dbe4dac573fc",
        "storage_key": "property/6767906449167478/019f630a-7622-7218-9912-dbe4dac573fc.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJKSz_k6ESkYARPL0gnLIMvGE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "false",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "poi_name": "Court Yard Plaza",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "633 Main St, Livingston, CA 95334, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630c-2f9f-766d-897a-7ef4a74dec82.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f630c-2f9f-766d-897a-7ef4a74dec82",
        "storage_key": "property/6767906449167478/019f630c-2f9f-766d-897a-7ef4a74dec82.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.livingstoncity.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15715130903919290141&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "court-yard-plaza",
      "poi_latitude": "37.3847727",
      "poi_longitude": "-120.7235727",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 209-394-3624",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-7622-7218-9912-dbe4dac573fc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f630a-7622-7218-9912-dbe4dac573fc",
        "storage_key": "property/6767906449167478/019f630a-7622-7218-9912-dbe4dac573fc.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJHazSfnoNkYARHWffdktcF9o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "false",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "poi_name": "Hagaman Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "19914 River Rd, Livingston, CA 95334, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630c-31aa-71f8-b336-f3ac22762a7f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f630c-31aa-71f8-b336-f3ac22762a7f",
        "storage_key": "property/6767906449167478/019f630c-31aa-71f8-b336-f3ac22762a7f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.countyofmerced.com/1410/Hagaman-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=3295096853677585502&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hagaman-park",
      "poi_latitude": "37.3630281",
      "poi_longitude": "-120.8491991",
      "poi_miles_from_property": "8.3 mi",
      "poi_walking_minutes": "2 hours 58 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 209-385-7434",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-7622-7218-9912-dbe4dac573fc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f630a-7622-7218-9912-dbe4dac573fc",
        "storage_key": "property/6767906449167478/019f630a-7622-7218-9912-dbe4dac573fc.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJy0MUTQALkYARXrT1VyGJui0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "false",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "poi_name": "Merced Transpo",
      "poi_type": "Transportation & Transit",
      "poi_address": "Merced, CA 95340, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630c-3806-770e-9d64-d23b513d422d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f630c-3806-770e-9d64-d23b513d422d",
        "storage_key": "property/6767906449167478/019f630c-3806-770e-9d64-d23b513d422d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=5324896356951895409&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "merced-transpo",
      "poi_latitude": "37.3013117",
      "poi_longitude": "-120.4878965",
      "poi_miles_from_property": "15.6 mi",
      "poi_walking_minutes": "5 hours 40 mins",
      "poi_biking_minutes": "1 hour 24 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630c-41b8-7775-a9e1-399761d14f72.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f630c-41b8-7775-a9e1-399761d14f72",
        "storage_key": "property/6767906449167478/019f630c-41b8-7775-a9e1-399761d14f72.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJr6fbz_hCkYARca3jLQbV5Uk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "false",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "poi_name": "Amtrak Merced",
      "poi_type": "Transportation & Transit",
      "poi_address": "324 W 24th St, Merced, CA 95340, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630c-32c3-70c8-bd2e-ec6855834e03.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f630c-32c3-70c8-bd2e-ec6855834e03",
        "storage_key": "property/6767906449167478/019f630c-32c3-70c8-bd2e-ec6855834e03.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amtrak.com/stations/mcd",
      "poi_directions_map_url": "https://maps.google.com/?cid=2910773204816031003&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amtrak-merced",
      "poi_latitude": "37.307325",
      "poi_longitude": "-120.4768152",
      "poi_miles_from_property": "16.2 mi",
      "poi_walking_minutes": "5 hours 53 mins",
      "poi_biking_minutes": "1 hour 23 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 866-332-1573",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-761f-73e5-9e3b-ef90cb7f5772.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f630a-761f-73e5-9e3b-ef90cb7f5772",
        "storage_key": "property/6767906449167478/019f630a-761f-73e5-9e3b-ef90cb7f5772.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ65XZbKpDkYARG-3Izs4kZSg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "false",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "poi_name": "Merced Regional Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "20 Macready Dr, Merced, CA 95341, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630c-362b-72bc-9977-b91a7584c3b3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f630c-362b-72bc-9977-b91a7584c3b3",
        "storage_key": "property/6767906449167478/019f630c-362b-72bc-9977-b91a7584c3b3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://flymercedairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7900837499262681416&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "merced-regional-airport",
      "poi_latitude": "37.2885205",
      "poi_longitude": "-120.5155805",
      "poi_miles_from_property": "15.4 mi",
      "poi_walking_minutes": "5 hours 36 mins",
      "poi_biking_minutes": "1 hour 31 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 209-385-6873",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630c-41bc-770a-94d5-c9dc0439bd57.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f630c-41bc-770a-94d5-c9dc0439bd57",
        "storage_key": "property/6767906449167478/019f630c-41bc-770a-94d5-c9dc0439bd57.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJHyT7UZBCkYARSEGjW9hppW0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "false",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "poi_name": "Merced-Castle Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "2150 Shuttle Dr, City of Atwater, CA 95301, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630c-365b-737d-9c2f-b52efa713fae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f630c-365b-737d-9c2f-b52efa713fae",
        "storage_key": "property/6767906449167478/019f630c-365b-737d-9c2f-b52efa713fae.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.flycastleairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13604342776847312397&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "merced-castle-airport",
      "poi_latitude": "37.3785141",
      "poi_longitude": "-120.5690502",
      "poi_miles_from_property": "9.5 mi",
      "poi_walking_minutes": "3 hours 28 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 209-385-7686 ext. 4180",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630c-41bc-770a-94d5-c9dc0439bd57.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f630c-41bc-770a-94d5-c9dc0439bd57",
        "storage_key": "property/6767906449167478/019f630c-41bc-770a-94d5-c9dc0439bd57.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJG0mqjcJqkYARDaaiOK1VzLw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "false",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "poi_name": "Transit Joint Powers Auth",
      "poi_type": "Transportation & Transit",
      "poi_address": "369 W 18th St, Merced, CA 95340, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=4294851442577601827&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "transit-joint-powers-auth",
      "poi_latitude": "37.3020299",
      "poi_longitude": "-120.4809426",
      "poi_miles_from_property": "16.0 mi",
      "poi_walking_minutes": "5 hours 50 mins",
      "poi_biking_minutes": "1 hour 24 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 209-723-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-761f-73e5-9e3b-ef90cb7f5772.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f630a-761f-73e5-9e3b-ef90cb7f5772",
        "storage_key": "property/6767906449167478/019f630a-761f-73e5-9e3b-ef90cb7f5772.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyyDr6AFDkYARI3XpxaFgmjs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "false",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "poi_name": "YARTS Yosemite Area Transportation",
      "poi_type": "Transportation & Transit",
      "poi_address": "357 W 18th St, Merced, CA 95340, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630c-3972-74e2-983c-13c5ba55a12f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f630c-3972-74e2-983c-13c5ba55a12f",
        "storage_key": "property/6767906449167478/019f630c-3972-74e2-983c-13c5ba55a12f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.yarts.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6801083848359375606&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "yarts-yosemite-area-transportation",
      "poi_latitude": "37.3019043",
      "poi_longitude": "-120.4808559",
      "poi_miles_from_property": "16.0 mi",
      "poi_walking_minutes": "5 hours 50 mins",
      "poi_biking_minutes": "1 hour 24 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 209-723-3111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-761f-73e5-9e3b-ef90cb7f5772.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f630a-761f-73e5-9e3b-ef90cb7f5772",
        "storage_key": "property/6767906449167478/019f630a-761f-73e5-9e3b-ef90cb7f5772.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLWJAkn1CkYAR9nIb9blNYl4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "false",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "poi_name": "Merced County Transit",
      "poi_type": "Major Employers & Offices",
      "poi_address": "880 Thornton Rd, Merced, CA 95341, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.mercedthebus.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14881475144451042040&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "merced-county-transit",
      "poi_latitude": "37.2970161",
      "poi_longitude": "-120.5225296",
      "poi_miles_from_property": "14.5 mi",
      "poi_walking_minutes": "5 hours 16 mins",
      "poi_biking_minutes": "1 hour 32 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 209-384-3111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-7655-7212-ba46-f7b15bcb5c29.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f630a-7655-7212-ba46-f7b15bcb5c29",
        "storage_key": "property/6767906449167478/019f630a-7655-7212-ba46-f7b15bcb5c29.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVRG4TnlCkYAR-CrPZsyehc4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "false",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "poi_name": "Fresno Yosemite International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "5175 E Clinton Way, Fresno, CA 93727, USA",
      "poi_short_description": "Airport showcasing art related to the nearby national parks & a huge walk-through sequoia tree.",
      "poi_long_description": "Airport showcasing art related to the nearby national parks & a huge walk-through sequoia tree.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630c-37af-7616-bbc7-557f65578b9a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f630c-37af-7616-bbc7-557f65578b9a",
        "storage_key": "property/6767906449167478/019f630c-37af-7616-bbc7-557f65578b9a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://flyfresno.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8058341233822912195&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fresno-yosemite-international-airport",
      "poi_latitude": "36.7782273",
      "poi_longitude": "-119.7165417",
      "poi_miles_from_property": "82.7 mi",
      "poi_walking_minutes": "1 day 6 hours",
      "poi_biking_minutes": "7 hours 14 mins",
      "poi_driving_minutes": "1 hour 18 mins",
      "poi_business_phone": "+1 559-621-4500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630c-41bc-770a-94d5-c9dc0439bd57.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f630c-41bc-770a-94d5-c9dc0439bd57",
        "storage_key": "property/6767906449167478/019f630c-41bc-770a-94d5-c9dc0439bd57.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJA6ui6B9clIARw87lQKj61G8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "false",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "poi_name": "Foster Farms Inc",
      "poi_type": "Shopping & Retail",
      "poi_address": "655 Davis St, Livingston, CA 95334, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630b-73f5-74d8-adeb-5dd2c1eaccfe.webp",
      "poi_featured_image_media": {
        "alt_text": "Loading docks with trailers at sunset.",
        "public_id": "019f630b-73f5-74d8-adeb-5dd2c1eaccfe",
        "storage_key": "property/6767906449167478/019f630b-73f5-74d8-adeb-5dd2c1eaccfe.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.fosterfarms.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2180985930415978178&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "foster-farms-inc",
      "poi_latitude": "37.39102829999999",
      "poi_longitude": "-120.7258075",
      "poi_miles_from_property": "220 ft",
      "poi_walking_minutes": "1 min",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 209-394-7901",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630c-419e-7558-ab0e-ce5a2a8d69e1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f630c-419e-7558-ab0e-ce5a2a8d69e1",
        "storage_key": "property/6767906449167478/019f630c-419e-7558-ab0e-ce5a2a8d69e1.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJh4ZB73cNkYARwraR-iVrRB4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "food_store"
    },
    {
      "id": "false",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "poi_name": "Gallo Vineyards Inc",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5953 Weir Ave, Livingston, CA 95334, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630c-376e-74eb-9a1d-9fd58282c390.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f630c-376e-74eb-9a1d-9fd58282c390",
        "storage_key": "property/6767906449167478/019f630c-376e-74eb-9a1d-9fd58282c390.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.gallo.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=655510594312232000&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gallo-vineyards-inc",
      "poi_latitude": "37.3738132",
      "poi_longitude": "-120.796686",
      "poi_miles_from_property": "5.4 mi",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 209-394-6200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-761f-73e5-9e3b-ef90cb7f5772.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f630a-761f-73e5-9e3b-ef90cb7f5772",
        "storage_key": "property/6767906449167478/019f630a-761f-73e5-9e3b-ef90cb7f5772.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJe2RZk4YMkYARQFx8mGnXGAk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "vineyard"
    },
    {
      "id": "false",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "poi_name": "Sensient Agricultural Ingredients",
      "poi_type": "Major Employers & Offices",
      "poi_address": "7474 Cressey Way, Livingston, CA 95334, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.sensientnaturalingredients.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14882863967596892742&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sensient-agricultural-ingredients",
      "poi_latitude": "37.3937536",
      "poi_longitude": "-120.6675544",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 209-394-7979",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-761f-73e5-9e3b-ef90cb7f5772.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f630a-761f-73e5-9e3b-ef90cb7f5772",
        "storage_key": "property/6767906449167478/019f630a-761f-73e5-9e3b-ef90cb7f5772.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ05H0Gx4TkYARRtIS_eyNis4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "false",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "poi_name": "Hilmar Headquarters and Innovation Center (not Visitor Center)",
      "poi_type": "Major Employers & Offices",
      "poi_address": "8901 Lander Ave, Hilmar, CA 95324, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630c-3921-76c3-8ea0-af2d419453e2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f630c-3921-76c3-8ea0-af2d419453e2",
        "storage_key": "property/6767906449167478/019f630c-3921-76c3-8ea0-af2d419453e2.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.hilmar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9110918698954626483&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hilmar-headquarters-and-innovation-center-not-visitor-center",
      "poi_latitude": "37.418087",
      "poi_longitude": "-120.8509216",
      "poi_miles_from_property": "9.7 mi",
      "poi_walking_minutes": "3 hours 29 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 209-656-1196",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-761f-73e5-9e3b-ef90cb7f5772.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f630a-761f-73e5-9e3b-ef90cb7f5772",
        "storage_key": "property/6767906449167478/019f630a-761f-73e5-9e3b-ef90cb7f5772.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpzP_cqcJkYARs5Wn9Eh8cH4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "false",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "poi_name": "Livingston Union School District",
      "poi_type": "Major Employers & Offices",
      "poi_address": "922 B St, Livingston, CA 95334, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.lusd.k12.ca.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18322190382606012805&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "livingston-union-school-district",
      "poi_latitude": "37.3856625",
      "poi_longitude": "-120.7284038",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 209-394-5400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630c-40f0-72e7-93d2-aa5bb31a874f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f630c-40f0-72e7-93d2-aa5bb31a874f",
        "storage_key": "property/6767906449167478/019f630c-40f0-72e7-93d2-aa5bb31a874f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJs6AFsXYNkYARhVFP7hN_Rf4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "false",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "poi_name": "Livingston City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1416 C St, Livingston, CA 95334, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-558a-720c-9a80-f2c253e9d95c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f630a-558a-720c-9a80-f2c253e9d95c",
        "storage_key": "property/6767906449167478/019f630a-558a-720c-9a80-f2c253e9d95c.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.cityoflivingston.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=446183166125182421&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "livingston-city-hall",
      "poi_latitude": "37.3847332",
      "poi_longitude": "-120.7228977",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 209-394-8041",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-7655-7212-ba46-f7b15bcb5c29.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f630a-7655-7212-ba46-f7b15bcb5c29",
        "storage_key": "property/6767906449167478/019f630a-7655-7212-ba46-f7b15bcb5c29.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfUjienoNkYAR1Y2mwTkpMQY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "false",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "poi_name": "Merced County Administration Services Department",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2222 M St, Merced, CA 95340, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.co.merced.ca.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17743115194134624323&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "merced-county-administration-services-department",
      "poi_latitude": "37.3070362",
      "poi_longitude": "-120.4815326",
      "poi_miles_from_property": "16.1 mi",
      "poi_walking_minutes": "5 hours 51 mins",
      "poi_biking_minutes": "1 hour 22 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 209-385-7366",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167478/019f630a-7655-7212-ba46-f7b15bcb5c29.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f630a-7655-7212-ba46-f7b15bcb5c29",
        "storage_key": "property/6767906449167478/019f630a-7655-7212-ba46-f7b15bcb5c29.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJG40bS1VCkYARQ_g6E0M1PPY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    }
  ],
  "office_hours": [
    {
      "id": "false",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "day": "MON",
      "open_time": "07:30",
      "close_time": "14:00"
    },
    {
      "id": "false",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "day": "TUE",
      "open_time": "07:30",
      "close_time": "14:00"
    },
    {
      "id": "false",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "day": "WED",
      "open_time": "07:30",
      "close_time": "14:00"
    },
    {
      "id": "false",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "day": "THU",
      "open_time": "07:30",
      "close_time": "17:00"
    },
    {
      "id": "false",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "day": "FRI",
      "open_time": "07:30",
      "close_time": "14:00"
    }
  ],
  "reviews": [
    {
      "id": "false",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "rating": "5",
      "name": "Joseph Economu",
      "text": "To help you out the first building you come to after the guard shack is dc1. The address on your paperwork will say c102 dc1. The shipping and receiving office for that is between doors 7 and 8. If your paperwork says c122 dc2, go around the first building and you'll drive straight into DC number two straight at the shipping and receiving office at the glass windows there'll be a big sign that says c122 dc2. The first building I didn't see any signage for it. The guys at the guard shack have no idea where to send you after you get here. I guess Foster farms isn't smart enough to give them this map and direct you where to go",
      "date": "2025-04-19",
      "title": "false"
    },
    {
      "id": "false",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "rating": "4",
      "name": "Andy Lou",
      "text": "Seem ok. Delivery of dry  appointment 0700 check ✅ security gate 0600 done by 0745",
      "date": "2025-01-21",
      "title": "false"
    },
    {
      "id": "false",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "rating": "5",
      "name": "Abey Malhi",
      "text": "Picking up checkin 7:30am check out 8:30 am",
      "date": "2026-05-22",
      "title": "false"
    }
  ],
  "virtual_tours": [],
  "faqs": [],
  "lead_collectors": [],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "page_item_url": "wheelchair-accessible-apartments-livingston-ca",
      "search_query": "wheelchair accessible apartments in Livingston CA",
      "category": "Amenity",
      "h1_title": "Wheelchair Accessible Apartments in Livingston, CA",
      "h2_subtitle": "Discover our wheelchair-friendly features at Corn Dog Manufacturer. Perfectly designed for ease of mobility in Livingston, CA.",
      "page_copy": "Welcome to Corn Dog Manufacturer, where accessibility meets comfort in Livingston, CA. Our wheelchair accessible apartments are specifically designed to cater to all your needs, ensuring every resident enjoys easy navigation throughout their living space. Located in the heart of Livingston, our homes provide not just accessibility but also proximity to local conveniences, making day-to-day living hassle-free for everyone.\n\nExperience the benefits of wheelchair accessibility with features like easily navigable pathways and spacious parking options, including free parking on-site. At Corn Dog Manufacturer, we pride ourselves on creating a welcoming environment for all residents. Whether you're exploring Merced County or enjoying the comforts of your home, you’ll appreciate the thoughtful design and accessible amenities available. Join the community where everyone feels at home, with every amenity tailored for inclusivity.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Wheelchair Accessible Apts in Livingston, CA",
      "seo_description": "Discover wheelchair accessible apartments at Corn Dog Manufacturer in Livingston, CA. Enjoy easy mobility and local conveniences.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "page_item_url": "apartments-with-free-parking-merced-county",
      "search_query": "apartments with free parking Merced County",
      "category": "Amenity",
      "h1_title": "Apartments with Free Parking in Merced County",
      "h2_subtitle": "Enjoy convenient living at Corn Dog Manufacturer with free parking included. Situated in the heart of Merced County.",
      "page_copy": "Corn Dog Manufacturer offers a unique living experience in Merced County with the added benefit of free parking. Residents appreciate the convenience of our easily accessible and spacious parking lot, allowing them to come and go with ease. Located in Livingston, our community not only provides complimentary parking but also a warm and welcoming atmosphere.\n\nLiving at Corn Dog Manufacturer, you'll find that everything you need is within reach, from local dining options to entertainment venues. The free parking adds a layer of convenience that enhances your lifestyle, eliminating the stress of searching for a spot. Our prime location in Livingston makes our apartments an ideal choice for those seeking comfort with practicality. Embrace a new standard of living where convenience is part of your everyday experience.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Free Parking - Merced County",
      "seo_description": "Find apartments with free parking at Corn Dog Manufacturer in Merced County. Discover convenient living in a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "page_item_url": "livingston-ca-free-parking-apartment",
      "search_query": "Livingston CA free parking apartment",
      "category": "Amenity",
      "h1_title": "Livingston, CA Free Parking Apartment",
      "h2_subtitle": "Discover the perfect apartment in Livingston, CA with free parking at Corn Dog Manufacturer. Comfort and convenience await you.",
      "page_copy": "At Corn Dog Manufacturer in Livingston, CA, enjoy the ease of free parking right at your doorstep. Our apartments are designed to offer you a hassle-free living experience, combining comfort with the convenience of a dedicated parking lot. Located in the vibrant city of Livingston, our community ensures you have everything you need within reach while eliminating the stress of parking fees.\n\nExperience the charm of Livingston without the worry of where to park your vehicle. Our prime location provides easy access to local attractions and daily necessities, making it an ideal place to call home. Whether you're commuting for work or exploring Merced County, the free parking at Corn Dog Manufacturer makes every journey smoother. Embrace the benefits of a well-situated home where convenience and accessibility are prioritized.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Livingston, CA Free Parking Apartment",
      "seo_description": "Find your ideal Livingston, CA apartment with free parking at Corn Dog Manufacturer. Enjoy accessible, stress-free living in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "page_item_url": "wheelchair-friendly-living-livingston-95334",
      "search_query": "wheelchair friendly living Livingston 95334",
      "category": "Amenity",
      "h1_title": "Wheelchair Friendly Living in Livingston 95334",
      "h2_subtitle": "Experience accessible and welcoming community living in zip code 95334. Corn Dog Manufacturer offers wheelchair-friendly accommodations in Livingston.",
      "page_copy": "Welcome to Corn Dog Manufacturer, where we proudly offer wheelchair friendly living in the heart of Livingston, zip code 95334. Our thoughtfully designed spaces ensure ease of movement and accessibility for all residents, fostering a community that cares about inclusivity. Whether you're moving into our conveniently located apartments or simply visiting, you'll feel right at home in a place that prioritizes ease and comfort.\n\nLivingston's charm and convenience are at your doorstep, with wheelchair-accessible features ensuring seamless mobility throughout our property. Our free parking and accessible pathways make coming and going simple and straightforward. At Corn Dog Manufacturer, we understand the importance of creating a living environment that caters to everyone's needs. Discover the perfect blend of comfort and accessibility within our vibrant community.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Wheelchair Friendly Living in Livingston, CA 95334",
      "seo_description": "Corn Dog Manufacturer in Livingston offers wheelchair-friendly living with free parking, set in the accessible zip code 95334.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "page_item_url": "accessible-apartment-features-merced-county",
      "search_query": "accessible apartment features Merced County",
      "category": "Amenity",
      "h1_title": "Accessible Apartment Features in Merced County",
      "h2_subtitle": "Corn Dog Manufacturer offers fully accessible apartment features in Merced County, ensuring convenience and comfort in every aspect of living.",
      "page_copy": "Corn Dog Manufacturer, located in Merced County, is committed to providing accessible apartment features that cater to a diverse range of needs. Our community is designed to ensure that everyone can enjoy their living space without limitations. From wheelchair-accessible pathways to free parking, our amenities provide a barrier-free environment that enhances daily life.\n\nOur property’s prime location in Livingston makes getting around town convenient and effortless. Residents benefit from features that are both practical and thoughtfully designed, ensuring that every unit meets the highest standards of accessibility. At Corn Dog Manufacturer, we believe in creating an inclusive community where everyone feels at home, making us a top choice for accessible apartment living in Merced County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Accessible Apartment Features - Merced County",
      "seo_description": "Discover accessible apartment features at Corn Dog Manufacturer in Merced County, providing convenience and inclusion in a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "page_item_url": "studio-apartment-livingston-ca",
      "search_query": "studio apartment livingston ca",
      "category": "Floorplan",
      "h1_title": "Studio Apartment in Livingston, CA",
      "h2_subtitle": "Explore comfortable and modern studio apartment living at Corn Dog Manufacturer in Livingston, CA. Ideal living with ample amenities awaits.",
      "page_copy": "Discover the simplicity and style of studio apartment living at Corn Dog Manufacturer, nestled in the vibrant community of Livingston, CA. Our studio apartments offer a perfect blend of comfort and efficiency, making them an ideal choice for singles or couples looking for a cozy yet modern living space. With a focus on convenience, each unit is designed to maximize your living experience without compromising on essential features.\n\nLocated in the heart of Livingston, our studio apartments provide easy access to the city's amenities, ensuring you're never far from what you need. Enjoy the added benefit of free parking and a wheelchair-accessible environment, adding to the seamless living experience. At Corn Dog Manufacturer, find a studio apartment that fits your lifestyle and enjoy the vibrant community that surrounds you.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartment in Livingston, CA",
      "seo_description": "Find modern studio apartments at Corn Dog Manufacturer in Livingston, CA. Enjoy convenient amenities and an ideal living space.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "page_item_url": "apartments-near-mcconnell-state-recreation",
      "search_query": "apartments near McConnell State Recreation Livingston CA",
      "category": "Park",
      "h1_title": "Apartments Near McConnell State Recreation",
      "h2_subtitle": "Discover the perfect living options near McConnell State Recreation Area in Livingston, CA. Convenient, accessible, and vibrant community living awaits you.",
      "page_copy": "Experience the best of both worlds at Corn Dog Manufacturer, where modern living meets nature's beauty. Our apartments are conveniently located near McConnell State Recreation Area in Livingston, CA, providing easy access to all the outdoor adventures you love. Whether you're enjoying a weekend picnic or a spontaneous hike, our proximity ensures you can explore the great outdoors without the hassle of long travel.\n\nOur community not only offers a serene, nature-adjacent location but also comes with amenities like free parking and wheelchair accessibility, enhancing your daily living experience. Embrace the lifestyle you desire with both convenience and comfort at Corn Dog Manufacturer, situated just a stone's throw away from the natural splendor of McConnell State Recreation Area.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near McConnell State Recreation Area",
      "seo_description": "Find the perfect apartments near McConnell State Recreation in Livingston, offering nature access and comfort at Corn Dog Manufacturer.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "page_item_url": "apartments-near-joseph-gallo-park-merced-county",
      "search_query": "apartments close to Joseph Gallo Park Merced County",
      "category": "Park",
      "h1_title": "Apartments Close to Joseph Gallo Park",
      "h2_subtitle": "Live near the beautiful Joseph Gallo Park in Merced County. Enjoy serene park views and modern living at Corn Dog Manufacturer.",
      "page_copy": "Corn Dog Manufacturer offers the ideal apartment community for those looking to live close to the scenic Joseph Gallo Park in Merced County. Enjoy the luxury of having one of the area’s most beautiful parks just a short distance from your home, where you can indulge in leisurely walks, picnics, or morning jogs.\n\nOur community is crafted to provide comfort and enjoyment, featuring amenities like free parking and full wheelchair accessibility. Situated in the bustling Livingston area, Corn Dog Manufacturer not only provides easy access to green spaces but also brings you close to all the conveniences of city living. Experience a perfect blend of nature and modernity right at your doorstep!",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Joseph Gallo Park",
      "seo_description": "Enjoy living near Joseph Gallo Park at Corn Dog Manufacturer in Merced County. Access nature and urban amenities effortlessly.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "page_item_url": "living-near-livingston-memorial-park-95334",
      "search_query": "living near Livingston Memorial Park 95334",
      "category": "Park",
      "h1_title": "Living Near Livingston Memorial Park",
      "h2_subtitle": "Experience the charm of living near Livingston Memorial Park in the 95334 area. Enjoy park-side tranquility and modern amenities at Corn Dog Manufacturer.",
      "page_copy": "Come home to Corn Dog Manufacturer, where living near Livingston Memorial Park allows you to enjoy the best of Livingston, CA's scenic beauty. Our convenient location just a short walk away from the park offers endless opportunities for enjoying outdoor activities, family picnics, or peaceful strolls amid nature's beauty.\n\nResidents appreciate the thoughtful amenities available, including free parking and a wheelchair-accessible environment, which make life easier and more enjoyable. Situated in the heart of the 95334 area, Corn Dog Manufacturer not only provides picturesque park views but also places you within reach of Livingston’s vibrant community life and essential services. Discover the ideal balance of nature and convenience today.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Near Livingston Memorial Park",
      "seo_description": "Experience tranquil living near Livingston Memorial Park at Corn Dog Manufacturer, with easy access to nature and city life.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167478",
      "source": "generator",
      "page_item_url": "apartments-by-arakelian-park-livingston",
      "search_query": "apartments by Arakelian Park Livingston",
      "category": "Park",
      "h1_title": "Apartments by Arakelian Park Livingston",
      "h2_subtitle": "Discover comfortable living near Arakelian Park in Livingston. Enjoy spacious apartments with park access at Corn Dog Manufacturer.",
      "page_copy": "At Corn Dog Manufacturer, experience the delight of living just moments away from Arakelian Park in Livingston. Our community offers modern apartments that are perfect for those who enjoy being close to green spaces. Arakelian Park provides a serene environment for recreation and relaxation right on your doorstep.\n\nOur residents benefit from convenient amenities such as free parking and wheelchair accessibility, making Corn Dog Manufacturer a top choice for comfort and ease in Livingston. Immerse yourself in a community that combines the tranquility of park-side living with all the perks of city amenities. Discover a place where you can truly feel at home, just a stone's throw from Arakelian Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Arakelian Park Livingston",
      "seo_description": "Find your home near Arakelian Park in Livingston. Corn Dog Manufacturer offers modern living with park-side charm and amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "3"
    }
  ],
  "custom_rollout_phase": "3"
};

export const generatedAt = '2026-08-21T20:23:07.806Z';
